{
  "ACTIONS": {
    "CREATE": "Create",
    "CANCEL": "Cancel",
    "SAVE": "Save",
    "NEXT": "Next",
    "BACK": "Back",
    "FINISH": "Finish",
    "RETRY": "Retry",
    "APPLY": "Apply",
    "IMPORT": "Import",
    "SELECT": "Select",
    "SELECTED": "Selected",
    "SEARCH": "Search",
    "ADD": "Add",
    "DELETE": "Delete",
    "EDIT": "Edit",
    "SEND": "Send",
    "CONFIRM": "Confirm",
    "OK": "OK",
    "CRM": {
      "EXPORT": {
        "LABEL": "Export",
        "TITLE": "Export {{ objectType }}",
        "CONFIRMATION_MESSAGE": "This will export {{ total }} {{ objectType }}. Note that if the total number of {{ objectType }} exceeds 64000, only the first 64000 {{ objectType }} will be exported.",
        "CONFIRMATION_MESSAGE_ASYNC": "This will export {{ total }} {{ objectType }}.",
        "CONFIRM": "Export",
        "CANCEL": "Cancel",
        "DOWNLOADING": "Downloading...",
        "STARTED": "Export started. You can follow it in Exports.",
        "SUCCESS": "Exported {{ objectType }}",
        "ERROR": "Error exporting {{ objectType }}"
      }
    }
  },
  "ERRORS": {
    "GENERIC_MESSAGE": "Something went wrong",
    "GENERIC_LOAD_MESSAGE": "Could not load the page. Please try again.",
    "GENERIC_EDIT_MESSAGE": "There was an error updating. Please try again.",
    "RESOURCE_NOT_FOUND_ERROR": "Resource not found"
  },
  "CRM": {
    "CONTACT": "Contact",
    "COMPANY": "Company",
    "OPPORTUNITY": "Opportunity",
    "CUSTOM_OBJECT": "Custom object",
    "GOOGLE_LOOKUP": {
      "CONFIRM_OVERWRITE": {
        "TITLE": "Replace company details with Google data?",
        "MESSAGE": "These fields already have values and will be replaced: {{fields}}.",
        "CONFIRM": "Replace details",
        "CANCEL": "Keep my changes"
      },
      "FIELDS": {
        "ADDRESS_LINE_1": "Address line 1",
        "ADDRESS_LINE_2": "Address line 2",
        "CITY": "City",
        "STATE": "State/Province",
        "POSTAL_CODE": "Postal code",
        "COUNTRY": "Country",
        "WEBSITE": "Website",
        "PHONE_NUMBER": "Phone number"
      }
    }
  },
  "OBJECT_TYPES": {
    "CONTACT": "Contact",
    "CONTACT_PLURAL": "contacts",
    "COMPANY": "Company",
    "COMPANY_PLURAL": "companies",
    "OPPORTUNITY": "Opportunity",
    "OPPORTUNITY_PLURAL": "opportunities",
    "CUSTOM_OBJECT": "Custom object",
    "CUSTOM_OBJECT_PLURAL": "custom objects",
    "POTENTIAL_CONTACT": "Lead",
    "POTENTIAL_CONTACT_PLURAL": "leads",
    "FILE": "File",
    "TICKET": "Ticket",
    "ACTIVITY": "Activity",
    "NOTE": "Note",
    "EMAIL": "Email",
    "CALL": "Call",
    "MEETING": "Meeting",
    "TASK": "Task",
    "COMMUNICATION": "Communication",
    "OBJECT": "Object",
    "CUSTOM_FIELDS": "Custom fields",
    "FOR_LABEL": "for"
  },
  "LINE_ITEMS": {
    "SECTION_TITLE": "Items",
    "TOTAL": "Total",
    "EMPTY": "No line items",
    "ITEM_DESCRIPTION": "Item description",
    "UNIT_PRICE": "Unit price",
    "QUANTITY": "Quantity",
    "AMOUNT": "Amount",
    "SEARCH_PLACEHOLDER": "Search or add items...",
    "CREATE_OPTION": "Add \"{{term}}\"",
    "REMOVE": "Remove line item"
  },
  "CUSTOM_FIELDS": {
    "CREATE": "Create field",
    "EDIT": "Edit field",
    "DELETE": "Delete field",
    "FIELD_NAME": "Field name",
    "FIELD_DESCRIPTION": "Field description",
    "FIELD_TYPE": "Field type",
    "OBJECT": "Object",
    "LABELS": {
      "FIELDS": "Fields",
      "CONFIGURATION": "Configuration",
      "BOARD_SETTINGS": "Board settings",
      "PIPELINES": "Pipelines",
      "PIPELINES_WARNING": "Pipelines created will be based on possible values for this field at the time of creation. When you add new possible values for the field, they will not show up as stages in the pipeline unless you recreate the pipeline.",
      "SELECT_FIELD_FOR_PIPELINE": "Field",
      "DELETE_PIPELINE": "Delete pipeline",
      "PIPELINE_NAME": "Pipeline name",
      "ADD_PIPELINE": "Add pipeline",
      "SEARCH_FIELD": "Search fields",
      "NO_FIELDS_FOUND": "No fields found",
      "FAILED_TO_LOAD_FIELDS": "Failed to load fields",
      "SAVE": "Save",
      "SAVE_SUCCESS": "Pipelines saved successfully",
      "SAVE_FAILED": "Failed to save pipelines, please try again",
      "REQUIRED_FIELDS": "All pipeline rows require a name and a field selection",
      "CURRENT_STAGES": "Current stages",
      "NEW_STAGES": "New stages"
    },
    "FIELD_TYPES": {
      "DATE": "Date",
      "DATE_TIME": "Date and time",
      "INTEGER": "Number",
      "STRING": "Text",
      "STRING_LIST": "Text list",
      "FLOAT": "Decimal number",
      "EMAIL": "Email",
      "PHONE_NUMBER": "Phone number",
      "BOOLEAN": "True or false",
      "TAG": "Tag",
      "GEOPOINT": "Location",
      "CURRENCY": "Currency"
    },
    "FIELD_EXAMPLES": {
      "DATE": "e.g. birthday",
      "DATE_TIME": "e.g. next meeting",
      "INTEGER": "e.g. number of employees",
      "STRING": "e.g. address",
      "STRING_LIST": "e.g. tags or categories",
      "FLOAT": "e.g. review score"
    },
    "ERROR": {
      "FIELD_NAME_REQUIRED": "Field name is required",
      "FIELD_TYPE_REQUIRED": "Field type is required",
      "OBJECT_REQUIRED": "Object is required",
      "FAILED_TO_CREATE": "Failed to create custom field",
      "FAILED_TO_EDIT": "Failed to edit custom field",
      "FAILED_TO_DELETE": "Failed to delete custom field",
      "INVALID_FORM": "Almost there! Please correct the highlighted issues"
    },
    "SUCCESS": {
      "CREATED": "Custom field created successfully",
      "EDITED": "Custom field updated successfully",
      "DELETED": "Custom field deleted successfully"
    },
    "WARNING": {
      "RESTRICTED_VALUES_SAVE_FAILED": "Field options could not be saved",
      "RESTRICTED_VALUES_UPDATE_FAILED": "Field options could not be updated"
    },
    "DELETE_MODAL": {
      "TITLE": "Delete custom field?",
      "DESCRIPTION": "Are you sure you want to delete this custom field? This cannot be undone."
    },
    "SYSTEM_FIELDS_MESSAGE": "This is a system field and cannot be edited.",
    "SYSTEM_FIELDS_RESTRICTED_VALUES_MESSAGE": "This is a system field. Only field options can be modified.",
    "READ_ONLY": "Read-only access",
    "READ_ONLY_DESCRIPTION": "When enabled, this field can only be updated through  AI, automations or the API, not through the UI.",
    "MARK_AS_READ_ONLY": "Mark field as read-only",
    "READ_ONLY_DISABLED_TOOLTIP": "This is a system field, so it cannot be edited. It can only be updated through AI, automations or the API.",
    "RESTRICT_TO_SPECIFIC_VALUES": "Restrict to specific values",
    "RESTRICT_TO_SPECIFIC_VALUES_DESCRIPTION": "Limit input to a predefined list of values (e.g., dropdown-style options).",
    "RESTRICTED_VALUES": {
      "LABEL": "Field options",
      "INPUT_VALUE": "Input Value",
      "ADD_VALUE": "+ Add value",
      "REMOVE_VALUE": "Remove value"
    },
    "EXTERNAL_ID": {
      "LABEL": "External Identifier",
      "SET": "Set",
      "SET_IDENTIFIER": "Set Identifier",
      "EDIT_IDENTIFIER": "Edit Identifier",
      "IDENTIFIER_VALIDATION_MESSAGE": "Only lowercase letters, numbers, dash (-) and underscore (_) permitted",
      "IDENTIFIER_DUPLICATE_MESSAGE": "This external identifier is currently in use",
      "EXTERNAL_IDENTIFIER_DESCRIPTION": "This is what will be used to identify this field when working with the API. It cannot be edited once the field is created."
    },
    "CUSTOM_OBJECT": {
      "TITLE": "CRM objects",
      "SINGULAR_NAME": "Singular name",
      "PLURAL_NAME": "Plural name",
      "DELETE_OBJECT": "Delete  object",
      "ADD_CUSTOM_OBJECT": "+ Add custom object",
      "SUCCESS": {
        "CREATED": "Custom object created successfully",
        "EDITED": "Custom object updated successfully",
        "DELETED": "Custom object deleted successfully"
      },
      "ERROR": {
        "FAILED_TO_CREATE": "Failed to create custom object",
        "FAILED_TO_EDIT": "Failed to update custom object",
        "FAILED_TO_DELETE": "Failed to delete custom object",
        "INVALID_FORM": "Almost there! Please correct the highlighted issues"
      },
      "DELETE_MODAL": {
        "TITLE": "Delete {{ objectName }}?",
        "MESSAGE": "You are about to delete the custom object named {{ objectName }}. This will also delete everything inside it. This action cannot be undone.",
        "CONFIRM": "Delete {{ objectName }}"
      },
      "LIMIT_MODAL": {
        "TITLE": "Custom Object Limit Reached",
        "MESSAGE": "You currently have 3 custom objects, which is the maximum allowed. To create a new one, please delete an existing object that you no longer need.",
        "CONFIRM": "Got it"
      }
    },
    "ORGANIZE_LAYOUT": {
      "BUTTON": "Organize layout",
      "TITLE": "Organize field layout",
      "SUBTITLE": "Drag fields between groups or into the unassigned pool.",
      "DONE": "Done",
      "ADD_GROUP": "Add group",
      "RESET_TO_STANDARD": "Reset to standard",
      "RESET_CONFIRM_TITLE": "Reset to standard layout?",
      "RESET_CONFIRM_MESSAGE": "This will remove all your custom groups and field ordering for this object type. Fields will not be deleted.",
      "RESET_CONFIRM": "Reset",
      "UNASSIGNED": "Unassigned",
      "ALL_FIELDS_ASSIGNED": "All fields are assigned",
      "SORT_RECENT": "By recent update",
      "SORT_ALPHA": "Alphabetical",
      "GROUP_NAME_PLACEHOLDER": "Group name",
      "NEW_GROUP_NAME": "New group",
      "FIELD_GROUPS": "Field groups",
      "FIELDS_COUNT": "{{count}} fields",
      "GROUPS_COUNT": "{{count}} groups",
      "HIDDEN_COUNT": "{{count}} hidden",
      "SAVING": "Saving...",
      "SAVED": "Saved",
      "SAVE_ERROR": "Failed to save layout",
      "LOAD_ERROR": "Failed to load layout",
      "EMPTY_GROUP_ERROR": "Remove empty groups before saving",
      "GROUP_NAME_REQUIRED": "Group name is required",
      "DUPLICATE_GROUP_ERROR": "Group names must be unique",
      "HIDDEN": "Hidden fields",
      "RESTORE": "Restore",
      "HIDDEN_HINT": "Drag fields here to hide them",
      "HIDDEN_EMPTY": "Drop a field here to hide it",
      "BREADCRUMB": "Custom fields",
      "HIDDEN_HELPER": "Fields here are hidden from contact records",
      "ALL_CHANGES_SAVED": "All changes saved",
      "ADD_TO_GROUP": "Add to group",
      "MOVE_TO": "Move to",
      "REMOVE_TO_UNASSIGNED": "Remove to Unassigned",
      "RESTORE_TO_UNASSIGNED": "Restore to Unassigned",
      "SAVE_ERROR_EMPTY_GROUP": "Remove all empty groups before saving",
      "SAVE_ERROR_DUPLICATE_GROUP": "Two or more groups have the same ID — rename one before saving",
      "SAVE_ERROR_DUPLICATE_FIELD": "A field appears in more than one group — each field can only belong to one group",
      "SAVE_ERROR_PERMISSION": "You don't have permission to modify this layout",
      "SAVE_ERROR_SERVER": "Something went wrong on our end — please try again",
      "SAVE_ERROR_NETWORK": "Could not reach the server — check your connection and try again",
      "RESET_SUCCESS": "Layout reset to standard",
      "SORT_LABEL": "Sort unassigned by",
      "HIDE_FIELD": "Hide field",
      "FIELDS_SELECTED": "fields",
      "READ_ONLY_BADGE": "Read only"
    }
  },
  "ASSOCIATIONS": {
    "ACTIONS": {
      "TITLE": "Association",
      "REMOVE": "Remove association",
      "DETAILS": "View details",
      "EDIT_TAGS": "Edit association tags",
      "SHOW_MORE": "Show {{count}} more",
      "VIEW_ALL": "View all"
    },
    "SUCCESS": {
      "GENERIC": "Successfully created association",
      "REMOVE": "Successfully removed association",
      "PARTIAL_WITH_DELAY": "Created {{createdCount}} of {{totalCount}} associations. It may take a few minutes for them to appear",
      "PARTIAL_SUCCESS": "Created {{createdCount}} of {{totalCount}} associations",
      "SINGLE_FAILURE": "Failed to create association"
    },
    "ERROR": {
      "CREATE": "Failed to create association(s)",
      "REMOVE": "Failed to remove association"
    },
    "COMPANY": {
      "TITLE": "Companies",
      "ADD_COMPANY": "Add company",
      "ERROR": "Failed to create an account for this company",
      "INVITE": "+ Invite to {{appName}}",
      "INVITE_NO_EMAIL_ERROR": "Add an email address for this contact before inviting them",
      "LAST_LOGIN_DATE": "Last login: {{lastLoginDate}}",
      "NEVER_LOGGED_IN": "Never"
    },
    "PARENT_CHILD_COMPANIES": {
      "TITLE": "Companies",
      "CHILD_SECTION_TITLE": "Child companies",
      "PARENT_SECTION_TITLE": "Parent company",
      "ADD_CHILD_COMPANY": "Add child company",
      "SET_PARENT_COMPANY": "Set parent company",
      "ADD_CHILD_COMPANY_MODAL": {
        "TITLE": "Add child company to {{companyName}}",
        "SUCCESS": "Child company added",
        "ERROR": "Error adding child company"
      },
      "SET_PARENT_COMPANY_MODAL": {
        "TITLE": "Set parent company for {{companyName}}",
        "SUCCESS": "Parent company set",
        "ERROR": "Error setting parent company"
      }
    },
    "APP_ACCESS_MODAL": {
      "TITLE": "Invite to {{appName}}?",
      "DESCRIPTION": "<b>{{contactName}}</b> will be added as a user for {{companyName}}.",
      "PERMISSIONS_TOOLTIP": "You can edit their permissions at any time under the Accounts > Manage Users tab.",
      "SEND_WELCOME_EMAIL": "Send Set Password email (Welcome email)",
      "SEND_ONBOARDING_EMAIL": "Send Onboarding Email",
      "PREVIEW_EMAIL": "Preview email",
      "CUSTOM_MESSAGE_LABEL": "Custom introductory message",
      "CUSTOM_MESSAGE_PLACEHOLDER": "Add a custom greeting (optional)",
      "CUSTOM_MESSAGE_HINT": "Appears at the top of the Onboarding Email.",
      "INVITE": "Invite",
      "CANCEL": "Cancel",
      "SUCCESS": "Contact has been successfully invited",
      "ERROR": "Error inviting contact"
    },
    "MODAL": {
      "TITLE_CONTACT_MODAL": "Add companies to {{contactFullName}}",
      "ADD_ASSOCIATION": "Add company",
      "TITLE_COMPANY_MODAL": "Add contacts to {{companyName}}",
      "TITLE_ASSOCIATE_CONTACTS": "Add contacts to {{objectName}}",
      "TITLE_ASSOCIATE_COMPANIES": "Add companies to {{objectName}}",
      "TITLE_ASSOCIATION": "Association details",
      "TITLE_TAGS": "Association tags",
      "HINT_TAGS": "New tag...",
      "DESCRIPTION_TAGS": "Use tags to describe this relationship",
      "CREATE_NEW_CONTACT": "Create new contact"
    },
    "COMPANY_MODAL": {
      "PRIMARY_COMPANY": "Set as primary company",
      "PRIMARY_DESCRIPTION": "This will replace any current primary company associations"
    },
    "ADMIN_NOTES": {
      "TITLE": "Admin Notes"
    },
    "PRODUCTS": {
      "TITLE": "Products",
      "NO_PRODUCTS": "No products yet",
      "ACTIVE_SINCE": "Active since",
      "RENEWS": "Renews",
      "COMMITTED_UNTIL": "Committed until",
      "TRIAL_SINCE": "Trial since",
      "ENDS": "Ends",
      "DAYS_REMAINING": "{{days}} days remaining",
      "TRIAL_UPGRADE": "Upgrade product to continue service",
      "ERROR": "Error loading data, refresh and try again",
      "STATUS": {
        "TRIAL": "Trial",
        "TRIAL_ENDED": "Trial ended"
      }
    },
    "REPORTS": {
      "TITLE": "Reports"
    },
    "OPPORTUNITIES": {
      "TITLE": "Opportunities"
    },
    "UTM_ATTRIBUTES": {
      "TITLE": "UTM Attributes"
    },
    "AUTOMATIONS": {
      "TITLE": "Automations"
    },
    "CAMPAIGNS": {
      "TITLE": "Campaigns",
      "ADD_ASSOCIATION": "Add campaign",
      "START": "Start campaign...",
      "START_NOW": "Campaign will start on",
      "START_LATER": "Campaign will start at the scheduled time",
      "ADD_TO_CAMPAIGN": "Add to campaign",
      "STATUS": {
        "ONGOING": "Ongoing",
        "PAUSED": "Paused",
        "COMPLETED": "Completed"
      },
      "MENU": {
        "PAUSE": {
          "CONFIRMATION": {
            "TITLE": "Pause {{ title }} for {{ recipient }}?",
            "MESSAGE": "Scheduled campaign events will be paused for this recipient only. This action may take a few minutes to complete.",
            "CONFIRM": "Pause campaign",
            "DECLINE": "Cancel"
          },
          "PAUSE_CAMPAIGN": "Pause campaign",
          "SUCCESS": "Campaign paused",
          "FAILURE": "There was a problem pausing the campaign. Refresh the page and try again."
        },
        "RESUME": {
          "CONFIRMATION": {
            "TITLE": "Resume {{ title }} for {{ recipient }}?",
            "MESSAGE": "The campaign will resume as scheduled for this recipient only. This recipient won't receive emails they've already received. This action may take a few minutes to complete.",
            "CONFIRM": "Resume campaign",
            "DECLINE": "Cancel"
          },
          "RESUME_CAMPAIGN": "Resume campaign",
          "SUCCESS": "Campaign resumed",
          "FAILURE": "There was a problem resuming the campaign. Refresh the page and try again."
        }
      },
      "MODAL": {
        "SUCCESS": "Successfully added to campaign",
        "ERROR": "Error adding to campaign",
        "FAILED_ADDRESS_ERROR_EMAIL": "Failed to add contact. Email address missing.",
        "FAILED_ADDRESS_ERROR_SMS": "Failed to add contact. Phone number missing.",
        "UPDATED": "Last updated:",
        "NO_CAMPAIGNS": "No campaigns found",
        "SEARCH_PLACEHOLDER": "Search active campaigns"
      },
      "START_CAMPAIGN": {
        "NOW": "Now",
        "LATER": "Later"
      },
      "VIEW_ALL": "View all"
    },
    "FILES": {
      "TITLE": "Files",
      "ADD_FILE": "Add file",
      "ADD_FIRST_FILE": "Add first file",
      "PRIVATE": "Private",
      "PRIVATE_DESCRIPTION": "Only you and authorized users can access this file",
      "PUBLIC": "Public",
      "PUBLIC_DESCRIPTION": "Anyone with the link can access this file",
      "NO_FILES": "No files attached yet",
      "VIEW": "View",
      "DOWNLOAD": "Download",
      "REMOVE": "Remove file",
      "UPLOAD_SUCCESS": "File \"{{fileName}}\" uploaded successfully!",
      "UPLOAD_ERROR": "Failed to upload file. Please try again.",
      "REMOVE_SUCCESS": "File \"{{fileName}}\" removed successfully!",
      "REMOVE_ERROR": "Failed to remove file association. Please try again.",
      "ASSOCIATION_CREATED": "File associated successfully",
      "ASSOCIATION_ERROR": "Failed to associate file. Please try uploading again.",
      "DOWNLOAD_SUCCESS": "Downloading \"{{fileName}}\"...",
      "DOWNLOAD_ERROR": "Failed to download file. Please try again.",
      "VIEW_ERROR": "Failed to open file. Please try again."
    },
    "FULFILLMENT_PROJECTS": {
      "TITLE": "Projects",
      "SUBTITLE": {
        "DUE": "Due",
        "COMPLETED": "Completed"
      },
      "STATUS": {
        "OPEN": "Open",
        "IN_PROGRESS": "In progress",
        "WAITING_ON_CUSTOMER": "Waiting on customer",
        "COMPLETED": "Completed",
        "OVERDUE": "Overdue"
      },
      "NO_PROJECTS": "No projects yet"
    },
    "ORDERS": {
      "TITLE": "Orders"
    },
    "COMPANY_PRIORITIES": {
      "TITLE": "Company Priorities"
    },
    "PROPOSALS": {
      "TITLE": "Proposals"
    },
    "TASKS": {
      "TITLE": "Tasks"
    },
    "PANEL_IN_PROGRESS": {
      "BUTTON": "View / add {{ category }}",
      "DESCRIPTION": "We're still working on this! To add or view existing {{ category }}, you'll be taken back to the account details page.",
      "ALERT": {
        "TITLE": "The associations panel is still in progress",
        "DESCRIPTION": "- You'll be taken back to the legacy page to access some features."
      }
    },
    "CONTACT": {
      "TITLE": "Contacts",
      "ADD_ASSOCIATION": "Add contact",
      "ACTIONS": {
        "EDIT": "Edit contact",
        "SEND_ONBOARDING_EMAIL": "Send Onboarding Email"
      }
    },
    "REMOVE_DIALOG": {
      "TITLE": "Remove association?",
      "MESSAGE": "{{removeName}} will no longer be associated with {{fromName}}.",
      "CONFIRM": "Remove",
      "CANCEL": "Cancel",
      "SUCCESS": "Association removed",
      "ERROR": "Error removing association"
    },
    "ACCOUNT": {
      "TITLE": "Account",
      "CREATE_ACCOUNT": "Create account",
      "CREATE_DESCRIPTION": "Accounts handle the billing relationship with a company. Use them to submit orders, create invoices, and collect payments.",
      "GO_TO_ACCOUNT": "Go to account",
      "OPEN_BUSINESS_APP": "Open in"
    },
    "EDIT_ASSOCIATION_DIALOG": {
      "ACTION": "Edit association tags",
      "TITLE": "Association details",
      "SUCCESS": "Association tags updated",
      "ERROR": "Error updating tags"
    },
    "FORM_FIELD": {
      "PLACEHOLDER": "Associate object..."
    }
  },
  "CONTACT": {
    "TITLE": "Contacts",
    "OBJECT_TYPE": "Contact",
    "ALL_OBJECTS": "All contacts",
    "MY_OBJECTS": "My contacts",
    "ADD_OBJECT_BUTTON": "Create contact",
    "VIEW_OBJECT": "View contact",
    "CREATE_PAGE": {
      "TITLE": "Create contact",
      "SAVE": {
        "SUCCESS": "Contact creation was successful",
        "ERROR": "Something went wrong"
      },
      "LOAD": {
        "ERROR": "Something went wrong"
      }
    },
    "EDIT_PAGE": {
      "TITLE": "Edit contact",
      "SAVE": {
        "SUCCESS": "Contact was updated successfully"
      }
    },
    "ASSOCIATION_PANEL": {
      "TITLE": "Contacts",
      "ADD_ASSOCIATION": "Add contact",
      "TITLE_ASSOCIATE": "Add contacts to {{objectName}}",
      "CREATE_BUTTON": "Create and associate a new contact",
      "CONFIRM_EXISTING_PRIMARY_MODAL": {
        "TITLE": "Are you sure you want to proceed?",
        "CONFIRMATION_MESSAGE": "The following contacts already have primary associations and won't be created as primary:"
      }
    },
    "ASSOCIATION_FORM": {
      "TITLE": "Contacts",
      "PLACEHOLDER": "Associate contact..."
    },
    "CONTACT_PROFILE": {
      "TITLE": "Contact profile",
      "EDIT_CONTACT": "Edit contact",
      "ACTIVITIES_TIMELINE_TAB": "Activity",
      "ABOUT_TAB": "About",
      "ASSOCIATIONS_TAB": "Associations"
    },
    "PROFILE_PAGE": {
      "TITLE": "Contact profile",
      "EDIT": "Edit contact",
      "PREVIOUS_PAGE_TITLE": "Contacts",
      "ACTIVITIES_TIMELINE_TAB": "Activity",
      "ABOUT_TAB": "About",
      "ASSOCIATIONS_TAB": "Associations",
      "PERSONAL_EVENT": "Your personal event links",
      "MEETING_ICON_TOOLTIP": "Book a meeting",
      "UPLOAD_RECORDING_TOOLTIP": "Upload a call recording",
      "EMAIL_ICON_TOOLTIP": "Send an email",
      "PHONE_ICON_TOOLTIP": "Make a phone call",
      "CHAT_ICON_TOOLTIP": "Send a message",
      "NPS": "NPS: {{score}}",
      "MEETING_EVENT_LIST_TITLE": "Please select an event link",
      "LEAD_SCORE": "Score: {{score}}"
    },
    "UPLOAD_RECORDING": {
      "DIALOG_TITLE": "Upload a call recording",
      "DIALOG_SUBTITLE": "Upload your audio recording with this contact here.",
      "FILE_INPUT_LABEL": "Select audio file",
      "FILE_HINT": "MP3, WAV, OGG, AAC, FLAC, M4A, WMA, WEBM",
      "MEETING_DATE_LABEL": "Meeting date",
      "UPLOAD_BUTTON": "Upload",
      "SUCCESS_SNACKBAR": "Call recording upload started processing.",
      "ERROR_SNACKBAR": "Upload failed. Please try again."
    },
    "BULK_DELETE": {
      "TITLE": "Delete all contacts?",
      "CONFIRMATION_MESSAGE": "Are you sure you want to delete all {{ amount }} contact(s)?"
    },
    "ACTIVITIES_TIMELINE": {
      "EMPTY": {
        "IMAGE_ALT": "Graphic showing an abstract activity card floating",
        "HEADER": "Activities Timeline",
        "HINT": "Add an Activity"
      },
      "EMPTY_SEARCH": {
        "HEADER": "No activities found that match your search",
        "HINT": "Try changing the keywords"
      },
      "SECTIONS": {
        "UPCOMING": "Upcoming"
      }
    },
    "ACTIVITIES": {
      "UNKNOWN_NAME": "Your expert",
      "HEADER_ADDITIONAL_TEXT": {
        "NOTE": "added a note",
        "LOGGED_EMAIL": "logged an email",
        "LOGGED_CALL": "logged a call",
        "LOGGED_MEETING": "logged a meeting",
        "LOGGED_COMMUNICATION": "logged a message",
        "TASK": "was assigned a task",
        "CONVERSATION": "Conversation created"
      },
      "CREATED_FROM": "from",
      "CREATED_WITH": "with"
    },
    "RECORD_CHANGE_ACTIVITY": {
      "CREATED": "Contact created",
      "CREATED_VIA": "Contact created via",
      "DETAILS_UPDATED": "Contact details updated",
      "IMPORTANT_FIELD_UPDATED": "{{updatedField}} updated by",
      "IMPORTANT_FIELD_UPDATED_SALESPERSON": "Assigned to",
      "IMPORTANT_FIELD_UPDATED_SALESPERSON_NOT_ASSIGNED": "Unassigned",
      "IMPORTANT_FIELD_UPDATED_SALESPERSON_UNKNOWN": "deleted salesperson"
    },
    "LIST_OBJECTS_PAGE": {
      "BACK_TO_USERS": "Back to Manage Users"
    },
    "LIST_OBJECTS_TABLE": {
      "EMPTY_TABLE": {
        "IMAGE_ALT": "Graphic showing a contact to be filled in",
        "HEADER": "Create your first contact",
        "HINT": "Add a single contact or import existing contact data from a CSV file"
      },
      "CUSTOM_COLUMNS": {
        "FULL_NAME": "Name",
        "PRIMARY_COMPANY_NAME": "Primary company name"
      },
      "ACTIONS": {
        "EDIT": {
          "TITLE": "Edit contact"
        },
        "DELETE": {
          "ACTION": "Delete contact",
          "TITLE": "Delete {{ name }}?",
          "CONFIRMATION_MESSAGE": "This cannot be undone.",
          "CONFIRMATION_TEXT": "DELETE",
          "INSTRUCTIONS": "Type DELETE to confirm.",
          "CONFIRM": "Delete",
          "CANCEL": "Cancel",
          "SUCCESS": "Deleted contact",
          "ERROR": "Error deleting contact"
        },
        "DELETE_SELECTED": {
          "ACTION": "Delete contacts",
          "TITLE": "Delete contacts?",
          "CONFIRMATION_MESSAGE": "This cannot be undone.",
          "CONFIRMATION_TEXT": "DELETE",
          "INSTRUCTIONS": "Type DELETE to confirm.",
          "CONFIRM": "Delete",
          "CANCEL": "Cancel",
          "SUCCESS": "Deleted contacts",
          "ERROR": "Error deleting contacts"
        }
      },
      "PIPELINE": {
        "EMPTY_STATE": {
          "TITLE": "Set up your pipeline and create your first contact",
          "MESSAGE": "Start with a default pipeline, or create a custom pipeline that matches your sales process",
          "SETUP_PIPELINE": "Set up pipeline"
        }
      }
    },
    "TABLE_FILTERS": {
      "HEADER": "Contacts"
    },
    "STANDARD_FIELD_RULES": {
      "UNIQUE_FIELD_VALUE": {
        "ENFORCED": "A contact with this {{label}} already exists",
        "WARNING": "One or more contacts with this {{label}} already exists",
        "PERMISSION_DENIED": "A contact with this {{label}} already exists in your organization"
      },
      "E164_FORMAT": {
        "WARNING": "Incorrect phone number format (ex. +1 1234567890)"
      },
      "CONTACT": {
        "FIRST_OR_LAST_NAME_OR_PHONE_OR_EMAIL_REQUIRED": "A contact needs at least one of first name, last name, phone or email",
        "TAG_LIMIT": "A contact cannot have more than 25 tags"
      }
    },
    "VALIDATION_ERROR": {
      "RESTRICTED_VALUE": "{{label}} value is not allowed for contacts",
      "EMPTY_FIELD": "{{label}} cannot be empty for contacts",
      "FIELD_WITHOUT_IDENTIFICATION": "{{label}} must have identification for contacts",
      "DUPLICATE_FIELD_ID": "Duplicate {{label}} field detected for contact",
      "FIELD_DEFINITION_NOT_FOUND": "{{label}} field definition not found for contacts",
      "UNSUPPORTED_FIELD_TYPE": "{{label}} field type is not supported for contacts",
      "INVALID_VALUE_TYPE": "{{label}} has invalid value type for contacts",
      "TAG_EXCEEDS_LIMIT": "{{label}} tag exceeds character limit for contacts",
      "TAG_CANNOT_BE_EMPTY": "{{label}} tag cannot be empty for contacts",
      "INVALID_EMAIL": "{{label}} has invalid email format for contacts",
      "INVALID_CURRENCY_CODE": "{{label}} has invalid currency code for contacts",
      "PHONE_NATIONAL_NUMBER_EXCEEDS_LIMIT": "{{label}} phone number exceeds character limit for contacts",
      "PHONE_COUNTRY_CODE_EXCEEDS_LIMIT": "{{label}} country code exceeds character limit for contacts",
      "PHONE_EXTENSION_EXCEEDS_LIMIT": "{{label}} phone extension exceeds character limit for contacts",
      "STRING_EXCEEDS_LIMIT": "{{label}} exceeds character limit for contacts",
      "STRING_LIST_ITEM_EXCEEDS_LIMIT": "{{label}} list item exceeds character limit for contacts",
      "INVALID_URL": "{{label}} has invalid URL format for contacts",
      "GEOPOINT_LATITUDE_OUT_OF_RANGE": "{{label}} latitude must be between -90 and 90 degrees for contacts",
      "GEOPOINT_LONGITUDE_OUT_OF_RANGE": "{{label}} longitude must be between -180 and 180 degrees for contacts",
      "NOT_A_NUMBER": "{{label}} must be a number for contacts",
      "NOT_A_WHOLE_NUMBER": "{{label}} must be a whole number for contacts",
      "NOT_A_DATE": "{{label}} must be a date for contacts",
      "NOT_A_DATETIME": "{{label}} must be a date and time for contacts",
      "NOT_A_BOOLEAN": "{{label}} must be true or false for contacts",
      "NOT_A_CURRENCY_AMOUNT": "{{label}} must be a currency amount for contacts",
      "NOT_A_GEOPOINT": "{{label}} must be a latitude and longitude for contacts",
      "NOT_A_PHONE_NUMBER": "{{label}} must be a valid phone number for contacts",
      "RESTRICTED_VALUE_WITH_OPTIONS": "\"{{value}}\" is not one of the options for the contact field \"{{label}}\". Change it to one of: {{acceptedValues}}"
    },
    "SELECT_MODAL": {
      "ONE_SELECTED": "Add contact",
      "MORE_SELECTED": "Add {{totalSelected}} contacts",
      "NO_SELECTED": "Please select a contact",
      "CREATE_NEW": "Create new contact"
    },
    "SELECT_FIELD": "Select a contact field"
  },
  "POTENTIAL_CONTACT": {
    "TITLE": "Leads",
    "OBJECT_TYPE": "Lead",
    "ALL_OBJECTS": "All leads",
    "MY_OBJECTS": "My leads",
    "VIEW_OBJECT": "View lead",
    "LIST_OBJECTS_TABLE": {
      "EMPTY_TABLE": {
        "IMAGE_ALT": "Graphic showing a contact to be filled in",
        "HEADER": "No leads yet",
        "HINT": "Leads will appear here as they are discovered"
      },
      "ACTIONS": {
        "PROMOTE": {
          "ACTION": "Promote to contact",
          "ACTION_MULTI": "Promote to contacts",
          "SUCCESS": "Promoted to contact",
          "SUCCESS_MULTI": "Promoted {{ count }} leads",
          "ERROR": "Error promoting lead",
          "ERROR_MULTI": "Failed to promote {{ failed }} of {{ total }} leads"
        },
        "DISMISS": {
          "ACTION": "Dismiss",
          "ACTION_MULTI": "Dismiss",
          "TITLE": "Dismiss {{ name }}?",
          "TITLE_MULTI": "Dismiss {{ count }} leads?",
          "CONFIRMATION_MESSAGE": "This cannot be undone.",
          "CONFIRM": "Dismiss",
          "CANCEL": "Cancel",
          "SUCCESS": "Dismissed lead",
          "SUCCESS_MULTI": "Dismissed {{ count }} leads",
          "ERROR": "Error dismissing lead",
          "ERROR_MULTI": "Failed to dismiss {{ failed }} of {{ total }} leads"
        }
      }
    }
  },
  "ACTIVITY_TYPES": {
    "NOTE": "Note",
    "EMAIL": "Email",
    "CALL": "Call",
    "MEETING": "Meeting",
    "CAMPAIGN": "Campaign email",
    "TASK": "Task",
    "MORE": "More",
    "YESWARE_CAMPAIGN": "Yesware campaign email",
    "COMMUNICATION_SUBTYPES": {
      "INBOX": "Conversations",
      "SMS": "SMS",
      "CAMPAIGN_SMS": "Campaign SMS",
      "LINKEDIN": "LinkedIn"
    }
  },
  "ACTIVITY_LOGGER": {
    "ADD": "Add",
    "LOG_ACTIVITY": "Log activity",
    "CREATE_TASK": "Create task",
    "SAVE": "Save",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Successfully created activity",
    "ERROR_MESSAGE": "There was a problem creating your activity. Please try again.",
    "EDIT_SUCCESS_MESSAGE": "Successfully updated activity",
    "EDIT_ERROR_MESSAGE": "There was a problem updating your activity. Please try again.",
    "ERROR_SET_REQUIRED_FIELDS": "Fill all required fields and address all errors",
    "ERROR_REQUIRE_DESCRIPTION": "Description is required",
    "ERROR_MAX_LENGTH_EXCEEDED": "Description must be less than {{maxLength}} characters",
    "ERROR_REQUIRE_EMAIL_DIRECTION": "Email direction is required",
    "ERROR_REQUIRE_CALL_DIRECTION": "Call direction is required",
    "ERROR_REQUIRE_EMAIL_DATE": "Email date is required",
    "ERROR_REQUIRE_CALL_DATE": "Call date is required",
    "ERROR_REQUIRE_MEETING_DATE": "Meeting date is required",
    "ERROR_REQUIRE_TASK_DUE_DATE": "Task due date is required",
    "ERROR_REQUIRE_COMMUNICATION_DATE": "Date is required",
    "ERROR_REQUIRE_TASK_TYPE": "Task type is required",
    "ERROR_REQUIRE_TASK_ASSIGNEE": "Task assignee is required",
    "ERROR_REQUIRE_TASK_NAME_REQUIRED": "Task name is required",
    "ERROR_REQUIRE_COMMUNICATION_OUTCOME": "Outcome is required",
    "EMPTY_ASSOCIATIONS": "Activities must have at least one association",
    "NOTE_PLACEHOLDER": "Share an update...",
    "ASSOCIATIONS": "Associations",
    "ADD_COMPANY_ASSOCIATION": "Associate company...",
    "ADD_CONTACT_ASSOCIATION": "Associate contact...",
    "ADD_TEAM_MEMBER_ASSOCIATION": "Add team members...",
    "ADD_OPPORTUNITY_ASSOCIATION": "Associate opportunity...",
    "ADD_TAGS": "Add tags...",
    "TAGS": "Tags",
    "LOGGED_EMAIL": {
      "DATE_PLACEHOLDER": "Email date",
      "DESCRIPTION_PLACEHOLDER": "Describe the email...",
      "DIRECTION_PLACEHOLDER": "Email direction"
    },
    "LOGGED_CALL": {
      "DATE_PLACEHOLDER": "Call date",
      "NOTE_PLACEHOLDER": "Describe the call...",
      "DIRECTION_PLACEHOLDER": "Call direction",
      "OUTCOME_PLACEHOLDER": "Call outcome",
      "STATUS_PLACEHOLDER": "Call status"
    },
    "LOGGED_MEETING": {
      "DATE_PLACEHOLDER": "Meeting date",
      "NOTE_PLACEHOLDER": "Describe the meeting...",
      "DURATION_PLACEHOLDER": "Meeting duration",
      "OUTCOME_PLACEHOLDER": "Meeting outcome",
      "STATUS_PLACEHOLDER": "Meeting status"
    },
    "LOGGED_TASK": {
      "TITLE_PLACEHOLDER": "Add a task",
      "INSTRUCTIONS_PLACEHOLDER": "Add task instructions",
      "PRIORITY_PLACEHOLDER": "Task priority",
      "TYPE_PLACEHOLDER": "Task type",
      "DUE_DATE_PLACEHOLDER": "Task due date",
      "OWNER_PLACEHOLDER": "Task assignee",
      "CREATE": {
        "SUCCESS": "Successfully created task",
        "ERROR": "There was a problem creating your task. Please try again."
      },
      "EDIT": {
        "SUCCESS": "Successfully updated task",
        "ERROR": "There was a problem updating your task. Please try again."
      },
      "DELETE": {
        "CONFIRMATION_MODAL": {
          "TITLE": "Delete task?",
          "MESSAGE": "This action cannot be undone.",
          "CONFIRM": "Delete",
          "CANCEL": "Cancel"
        },
        "TYPE_WARN": "warn",
        "SUCCESS": "Successfully deleted task",
        "ERROR": "There was a problem deleting your task. Please try again."
      }
    },
    "LOGGED_COMMUNICATION": {
      "DIRECTION_PLACEHOLDER": "Outcome",
      "DESCRIPTION_PLACEHOLDER": "Share an update..",
      "DATE_PLACEHOLDER": "Date"
    },
    "LOGGED_FOLLOW_UP_TASK": {
      "CREATE": "Create follow-up task",
      "TITLE": "Follow-up task",
      "FOLLOW_UP_WITH": "Follow up with"
    },
    "ACTIVITY_TYPE_SELECTOR_ARIA_LABEL": "Activity type selector"
  },
  "ACTIVITY": {
    "FEED": {
      "TITLE": "Activity feed"
    },
    "TITLE": "Activity",
    "MENU": {
      "EDIT": "Edit activity",
      "COPY_LINK": "Copy link",
      "DELETE": "Delete activity",
      "REPLY": "Reply",
      "UPDATE_ASSOCIATIONS": "Update associations",
      "UPDATE_TAGS": "Update tags"
    },
    "UPDATE_TAGS": {
      "SUCCESS": "Tags updated",
      "ERROR": "Failed to update tags"
    },
    "UPDATE_ASSOCIATIONS": {
      "SUCCESS": "Associations updated",
      "ERROR": "Failed to update associations"
    },
    "AUDIO_PLAYBACK_ERROR": "Audio playback is not supported",
    "DIRECTION": "Direction",
    "OUTCOME": "Outcome",
    "STATUS": "Status",
    "DATE": "Date",
    "DURATION": "Duration",
    "LOCATION": "Location",
    "DUE": "Due",
    "OVERDUE": "Overdue",
    "OUTBOUND": "Outbound",
    "INBOUND": "Inbound",
    "FORWARDED": "Forwarded",
    "OUTCOME_OPTIONS": {
      "BUSINESS_REVIEW": "Business review",
      "DEMO_SCHEDULED": "Demo scheduled",
      "DEMO_COMPLETED": "Demo completed",
      "DISCOVERY": "Discovery",
      "INTERESTED": "Interested",
      "NO_INTEREST": "No interest",
      "PRESENTATION": "Presentation",
      "QUALITY_CONNECT": "Quality connect",
      "RESCHEDULING": "Rescheduling",
      "REFERRED": "Referred to other representatives",
      "TIMELINE_6_12_MONTHS": "Timeline 6-12 months"
    },
    "LOGGED_EMAIL": {
      "DIRECTION": "Email direction"
    },
    "LOGGED_CALL": {
      "DIRECTION": "Call direction",
      "STATUS": "Call status",
      "OUTCOME": "Call outcome"
    },
    "EMAIL_PRIVATE_CONTENT": "This email content is private and cannot be displayed",
    "PRIVATE": "Private",
    "EMAIL_TITLE": {
      "FORWARDED": "forwarded to",
      "INBOUND": "sent to",
      "OUTBOUND": "from",
      "BOUNCED": "bounced by",
      "CLICKED": "clicked by",
      "DEFERRED": "deferred for",
      "DELIVERED": "delivered to",
      "DROPPED": "dropped by",
      "DOWNLOADED": "downloaded by",
      "FAILED": "failed for",
      "OPENED": "opened by",
      "PROCESSED": "processed for",
      "RECEIVED": "received by",
      "REPLY": "replied by",
      "RECEIVED_REPLY": "replied by",
      "RESUBSCRIBED": "resubscribed by",
      "SEND": "sent to",
      "SENT": "sent to",
      "SPAM": "marked as spam for",
      "UNSUBSCRIBED": "unsubscribed by",
      "FORWARDED_V2": "forwarded",
      "INBOUND_V2": "sent",
      "OUTBOUND_V2": "from",
      "BOUNCED_V2": "bounced",
      "CLICKED_V2": "clicked",
      "DEFERRED_V2": "deferred",
      "DELIVERED_V2": "delivered",
      "DOWNLOADED_V2": "downloaded an attachment on",
      "DROPPED_V2": "dropped",
      "FAILED_V2": "failed",
      "OPENED_V2": "opened",
      "OPENED_APPLE_MPP_V2": "possibly opened",
      "APPLE_MPP_TOOLTIP": "Apple Mail can load tracking images automatically, so we can't confirm this was a real open.",
      "PROCESSED_V2": "processed",
      "RECEIVED_V2": "received",
      "REPLY_V2": "replied",
      "RECEIVED_REPLY_V2": "replied",
      "RESUBSCRIBED_V2": "resubscribed",
      "SEND_V2": "sent",
      "SENT_V2": "sent",
      "SPAM_V2": "marked as spam",
      "UNSUBSCRIBED_V2": "unsubscribed",
      "EMAIL_TO": "to",
      "EMAIL_FOR": "for",
      "EMAIL_BY": "by",
      "EMAIL_FROM": "from"
    },
    "EMAIL_STATUS": {
      "FORWARDED": "Forwarded",
      "BOUNCED": "Bounced",
      "CLICKED": "Clicked",
      "DEFERRED": "Deferred",
      "DELIVERED": "Delivered",
      "DROPPED": "Dropped",
      "DOWNLOADED": "Downloaded",
      "FAILED": "Failed",
      "OPENED": "Opened",
      "PROCESSED": "Processed",
      "RECEIVED": "Received",
      "REPLY": "Replied",
      "RESUBSCRIBED": "Resubscribed",
      "SEND": "Sent",
      "SENT": "Sent",
      "SPAM": "Marked as spam",
      "UNSUBSCRIBED": "Unsubscribed"
    },
    "SMS_TITLE": {
      "SENT": "sent to",
      "DELIVERED": "delivered to",
      "FAILED": "failed for",
      "UNDELIVERED": "undelivered to"
    },
    "TASK": {
      "DUE_DATE": "Due date",
      "ASSIGNED_TO": "Assigned to",
      "TYPE": "Type",
      "PRIORITY": "Priority",
      "LOW": "Low",
      "MEDIUM": "Medium",
      "HIGH": "High",
      "TO_DO": "To-do",
      "EMAIL": "Email",
      "CALL": "Call",
      "MESSAGE": "Message",
      "MEETING": "Meeting",
      "LINKEDIN": "LinkedIn"
    },
    "MEETING": {
      "TITLE": "Meeting",
      "SCHEDULED": "Scheduled",
      "RESCHEDULED": "Rescheduled",
      "COMPLETED": "Completed",
      "CANCELLED": "Cancelled",
      "NO_SHOW": "No show",
      "REMINDER_SENT": "Reminder sent",
      "REMINDER_DELIVERED": "Reminder delivered",
      "REMINDER_FAILED": "Reminder failed",
      "CONFIRMATION_SENT": "Confirmation sent",
      "CONFIRMATION_DELIVERED": "Confirmation delivered",
      "CONFIRMATION_FAILED": "Confirmation failed",
      "5_MIN": "5 minutes",
      "15_MIN": "15 minutes",
      "30_MIN": "30 minutes",
      "1_HOUR": "1 hour",
      "1_HOUR_30_MIN": "1 hour 30 minutes",
      "2_HOURS_OR_MORE": "2 hours or more",
      "STATUS_HEADER": {
        "SCHEDULED": "Meeting scheduled",
        "RESCHEDULED": "Meeting rescheduled",
        "CANCELLED": "Meeting cancelled",
        "COMPLETED": "Meeting completed",
        "NO_SHOW": "Meeting no show",
        "UNKNOWN_STATUS": "Meeting status unknown",
        "BY_OWNER": "by {{ownerName}}"
      },
      "SUMMARY_BY_AI": "Summarized by AI",
      "SENTIMENT_SCORE": "Sentiment score",
      "RAVEN_SCORE": "RAVEN score",
      "MEETING_ANALYSIS": {
        "VIEW_SUMMARY": "View summary",
        "VIEW_DETAILS": "View details",
        "VIEW_SUMMARY_TOOLTIP": "Click on the title to see the full summary",
        "SUMMARY_TITLE": "Summary",
        "KEY_TAKEAWAYS": "Key takeaways",
        "ACTION_ITEMS": "Action items",
        "SENTIMENT_SCORE": "Sentiment score",
        "ASSOCIATIONS": "Associations",
        "RAVEN_SCORE": "RAVEN score",
        "DOWNLOAD_TRANSCRIPT": "Download transcript",
        "VIEW_RECORDING": "View recording",
        "GO_TO_MEETING": "Go to meeting",
        "VIEW_MEETING": "View meeting",
        "VIEW_CALL": "View call",
        "CLOSE": "Close",
        "DOWNLOAD_WILL_START_SHORTLY": "Your download will start shortly",
        "FEEDBACK": {
          "TITLE": "What did you not like?",
          "INSTRUCTIONS": "Please select at least one reason why you did not like the AI generated meeting summary. This will help us make better summaries.",
          "INACCURATE_SUMMARY": "Inaccurate summary",
          "INACCURATE_TAKEAWAYS": "Inaccurate takeaways",
          "INACCURATE_ACTION_ITEMS": "Inaccurate action items",
          "LACK_OF_DETAILS": "Lack of details",
          "WRONG_SPEAKERS": "Wrong / unidentified speakers",
          "OTHER": "Other",
          "ADDITIONAL_INFO": "Additional information",
          "SEND_FEEDBACK": "Send feedback",
          "FEEDBACK_CANCEL": "Cancel",
          "SUCCESS": "Feedback sent successfully",
          "ERROR": "Error sending feedback"
        }
      }
    },
    "CALL": {
      "TITLE": "Call",
      "WITH": "with",
      "CONNECTED": "Connected",
      "BUSY": "Busy",
      "REJECTED": "Rejected",
      "LEFT_VOICEMAIL": "Left voicemail",
      "NO_ANSWER": "No answer",
      "NOT_IN_SERVICE": "Not in service",
      "WRONG_NUMBER": "Wrong number",
      "TRANSCRIPT": "Call transcript",
      "VIEW_TRANSCRIPT": "View call transcript",
      "TO_NUMBER": "To number",
      "FROM_NUMBER": "From number",
      "CALL_END_AI_HUNG_UP": "AI hung up call",
      "CALL_END_AI_TRANSFERRED": "AI transferred call",
      "CALL_END_CALLER_ENDED": "Caller ended call",
      "CALL_END_TIMED_OUT": "Timed out",
      "CALL_END_CARRIER_ERROR": "Carrier error",
      "CALL_END_PROVIDER_ERROR": "Provider error",
      "CALL_END_CONNECTION_ERROR": "Connection error"
    },
    "NOTE": {
      "FORM_SUBMITTED": "Form submitted",
      "LIST": {
        "LIST_MEMBERSHIP": "List membership",
        "ADDED_TO": "Added to",
        "REMOVED_FROM": "Removed from"
      }
    },
    "COMMUNICATION": {
      "TYPE": "Type",
      "CONVERSATION_CREATED": "Conversation created via",
      "CONVERSATION_EVENT": "Conversation event via"
    },
    "RECORD_CHANGE": {
      "CREATED": "Created",
      "CREATED_VIA": "Created via",
      "SALESPERSON": "Salesperson:",
      "IMPORTANT_FIELD_UPDATED_SALESPERSON_UNKNOWN": "Deleted salesperson",
      "BY": "by",
      "USER_UNKNOWN": "unknown"
    },
    "UNKNOWN_TITLE": "An activity occurred",
    "ASSOCIATION": "association",
    "ASSOCIATIONS": "associations",
    "POPOVER": {
      "CONTACTS": "Contacts",
      "COMPANIES": "Companies",
      "OPPORTUNITIES": "Opportunities",
      "TEAM_MEMBERS": "Team members"
    },
    "HIDE_RELATED_ACTIVITIES": "Hide related activities",
    "SHOW_RELATED_ACTIVITIES": "Show related activities",
    "LOGGED_ACTIVITY": {
      "HEADER_ADDITIONAL_TEXT": {
        "NOTE": "Note",
        "EMAIL": {
          "OUTBOUND": "Outbound email logged",
          "INBOUND": "Inbound email logged",
          "FORWARDED": "Forwarded email logged"
        },
        "CALL": {
          "OUTBOUND": "Outbound call logged",
          "INBOUND": "Inbound call logged"
        },
        "MEETING": "Meeting logged",
        "COMMUNICATION": {
          "INBOX": "Message logged",
          "SMS": "SMS logged",
          "LINKEDIN": "LinkedIn message logged"
        },
        "TASK": "Task assigned",
        "BY": "by",
        "TO": "to"
      }
    },
    "VALIDATION_ERROR": {
      "RESTRICTED_VALUE": "{{label}} value is not allowed for activities",
      "EMPTY_FIELD": "{{label}} cannot be empty for activities",
      "FIELD_WITHOUT_IDENTIFICATION": "{{label}} must have identification for activities",
      "DUPLICATE_FIELD_ID": "Duplicate {{label}} field detected for activity",
      "FIELD_DEFINITION_NOT_FOUND": "{{label}} field definition not found for activities",
      "UNSUPPORTED_FIELD_TYPE": "{{label}} field type is not supported for activities",
      "INVALID_VALUE_TYPE": "{{label}} has invalid value type for activities",
      "TAG_EXCEEDS_LIMIT": "{{label}} tag exceeds character limit for activities",
      "TAG_CANNOT_BE_EMPTY": "{{label}} tag cannot be empty for activities",
      "INVALID_EMAIL": "{{label}} has invalid email format for activities",
      "INVALID_CURRENCY_CODE": "{{label}} has invalid currency code for activities",
      "PHONE_NATIONAL_NUMBER_EXCEEDS_LIMIT": "{{label}} phone number exceeds character limit for activities",
      "PHONE_COUNTRY_CODE_EXCEEDS_LIMIT": "{{label}} country code exceeds character limit for activities",
      "PHONE_EXTENSION_EXCEEDS_LIMIT": "{{label}} phone extension exceeds character limit for activities",
      "STRING_EXCEEDS_LIMIT": "{{label}} exceeds character limit for activities",
      "STRING_LIST_ITEM_EXCEEDS_LIMIT": "{{label}} list item exceeds character limit for activities",
      "INVALID_URL": "{{label}} has invalid URL format for activities",
      "GEOPOINT_LATITUDE_OUT_OF_RANGE": "{{label}} latitude must be between -90 and 90 degrees for activities",
      "GEOPOINT_LONGITUDE_OUT_OF_RANGE": "{{label}} longitude must be between -180 and 180 degrees for activities"
    },
    "CUSTOM_FILTER": {
      "DURATION": {
        "HOURS": "hour",
        "MINUTES": "min",
        "SECONDS": "sec"
      }
    },
    "BULK_DELETE": {
      "TITLE": "Delete all tasks?",
      "CONFIRMATION_MESSAGE": "Are you sure you want to delete all {{ amount }} tasks?"
    }
  },
  "AI_SUMMARY": {
    "TITLE": "Profile summary",
    "ERROR": "Error loading profile summary",
    "NO_SUMMARY": "There isn't enough data to provide actionable insights. Check back later.",
    "INITIAL_MESSAGE": "Can you provide a short summary of {{name}}?",
    "REGENERATE_SUMMARY": "Regenerate summary",
    "ASK_AI_SALES_ASSISTANT": "Ask AI Sales Assistant",
    "ASK_AI": "Ask AI",
    "SHOW_LESS": "Show less",
    "SHOW_MORE": "Show more",
    "RESTRICTED_DESCRIPTION": "Turn meeting notes, emails, and customer data into a concise strategic overview.",
    "UNLOCK": "Unlock AI summary"
  },
  "AI_DRAFT": {
    "DRAFT_READY": "Draft ready"
  },
  "COMPANY": {
    "TITLE": "Companies",
    "OBJECT_TYPE": "Company",
    "ALL_OBJECTS": "All companies",
    "MY_OBJECTS": "My companies",
    "ADD_OBJECT_BUTTON": "Create company",
    "PROSPECT_OBJECT_BUTTON": "Find leads",
    "VIEW_OBJECT": "View company",
    "DEFAULT_NAME": "this company",
    "CREATE_PAGE": {
      "TITLE": "Create company",
      "SAVE": {
        "SUCCESS": "Company creation was successful"
      }
    },
    "EDIT_PAGE": {
      "TITLE": "Edit company",
      "SAVE": {
        "SUCCESS": "Company was updated successfully"
      }
    },
    "ASSOCIATION_PANEL": {
      "TITLE": "Companies",
      "ADD_ASSOCIATION": "Add company",
      "TITLE_ASSOCIATE": "Add companies to {{objectName}}",
      "CREATE_BUTTON": "Create and associate a new company",
      "SET_PRIMARY_MODAL": {
        "RADIO_BUTTON_TEXT": "Set as primary company",
        "RADIO_BUTTON_DESCRIPTION": "This will replace any current primary company associations"
      },
      "CHANGE_PRIMARY_DIALOG": {
        "TITLE": "Change primary company?",
        "MESSAGE": "{{newAssociationName}} will replace {{previousAssociationName}} as the primary company. "
      }
    },
    "ASSOCIATION_FORM": {
      "TITLE": "Companies",
      "PLACEHOLDER": "Associate company..."
    },
    "RECORD_CHANGE_ACTIVITY": {
      "CREATED": "Company created",
      "CREATED_VIA": "Company created via",
      "DETAILS_UPDATED": "Company details updated",
      "IMPORTANT_FIELD_UPDATED": "{{updatedField}} updated by",
      "IMPORTANT_FIELD_UPDATED_SALESPERSON": "Assigned to",
      "IMPORTANT_FIELD_UPDATED_SALESPERSON_NOT_ASSIGNED": "Unassigned",
      "IMPORTANT_FIELD_UPDATED_SALESPERSON_UNKNOWN": "deleted salesperson"
    },
    "OPPORTUNITY_CHANGE_ACTIVITY": {
      "OPPORTUNITY_UPDATED_BY": "Opportunity updated by",
      "OPPORTUNITY_UPDATED": "Opportunity updated",
      "STATUS_CHANGE_MESSAGE": "Open →",
      "REASON_MESSAGE": "Reason:",
      "NOTES_MESSAGE": "Notes:",
      "STATUS": "Status:",
      "BY": "by"
    },
    "PROFILE_PAGE": {
      "TITLE": "Company profile",
      "EDIT": "Edit company",
      "ACTIVITIES_TIMELINE_TAB": "Activity",
      "ABOUT_TAB": "About",
      "ASSOCIATIONS_TAB": "Associations",
      "PREVIOUS_PAGE_TITLE": "Companies",
      "LEAD_SCORE": "Score: {{score}}"
    },
    "BULK_DELETE": {
      "TITLE": "Delete all companies?",
      "CONFIRMATION_MESSAGE": "Are you sure you want to delete all {{ amount }} companies?"
    },
    "LIST_OBJECTS_PAGE": {
      "BACK_TO_ACCOUNTS": "Back to Manage Accounts"
    },
    "LIST_OBJECTS_TABLE": {
      "EMPTY_TABLE": {
        "IMAGE_ALT": "Graphic showing a company to be filled in",
        "HEADER": "Create your first company",
        "HINT": "Add a single company or import existing company data from a CSV file"
      },
      "ACTIONS": {
        "EDIT": {
          "TITLE": "Edit company"
        },
        "DELETE": {
          "ACTION": "Delete company",
          "TITLE": "Delete {{ name }}?",
          "CONFIRMATION_MESSAGE": "Deleting this company cannot be undone. Contacts that are associated with the company will remain, but they will no longer have the association.",
          "CONFIRMATION_TEXT": "DELETE",
          "INSTRUCTIONS": "Type DELETE to confirm.",
          "CONFIRM": "Delete",
          "CANCEL": "Cancel",
          "SUCCESS": "Deleted company",
          "ERROR": "Error deleting company"
        },
        "DELETE_SELECTED": {
          "ACTION": "Delete companies",
          "TITLE": "Delete companies?",
          "CONFIRMATION_MESSAGE": "This cannot be undone.",
          "CONFIRMATION_TEXT": "DELETE",
          "INSTRUCTIONS": "Type DELETE to confirm.",
          "CONFIRM": "Delete",
          "CANCEL": "Cancel",
          "SUCCESS": "Deleted companies",
          "ERROR": "Error deleting companies"
        },
        "OPEN_BUSINESS_APP": "Open in",
        "START_AUTOMATION": "Start automation",
        "RUN_BULK_ACTION": "More actions",
        "IMPERSONATE": "Impersonate",
        "APPLY_CONFIGURATION": "Apply blueprint",
        "APPLY_CONFIGURATION_LOAD_ERROR": "Failed to load selected accounts"
      },
      "PROFILE_PAGE": {
        "EDIT": "Edit company"
      },
      "PIPELINE": {
        "EMPTY_STATE": {
          "TITLE": "Set up your pipeline and create your first company",
          "MESSAGE": "Start with a default pipeline, or create a custom pipeline that matches your sales process",
          "SETUP_PIPELINE": "Set up pipeline"
        }
      }
    },
    "TABLE_FILTERS": {
      "HEADER": "Companies"
    },
    "STANDARD_FIELD_RULES": {
      "E164_FORMAT": {
        "WARNING": "Incorrect phone number format (ex. +1 1234567890)"
      },
      "UNIQUE_FIELD_VALUE": {
        "ENFORCED": "A company with this {{label}} already exists",
        "WARNING": "One or more companies with this {{label}} already exists"
      },
      "COMPANY": {
        "COMPANY_NAME_REQUIRED": "Company name is required",
        "TAG_LIMIT": "A company cannot have more than 25 tags",
        "CATEGORY_LIMIT": "A company cannot have more than 10 categories"
      }
    },
    "VALIDATION_ERROR": {
      "RESTRICTED_VALUE": "{{label}} value is not allowed for companies",
      "EMPTY_FIELD": "{{label}} cannot be empty for companies",
      "FIELD_WITHOUT_IDENTIFICATION": "{{label}} must have identification for companies",
      "DUPLICATE_FIELD_ID": "Duplicate {{label}} field detected for company",
      "FIELD_DEFINITION_NOT_FOUND": "{{label}} field definition not found for companies",
      "UNSUPPORTED_FIELD_TYPE": "{{label}} field type is not supported for companies",
      "INVALID_VALUE_TYPE": "{{label}} has invalid value type for companies",
      "TAG_EXCEEDS_LIMIT": "{{label}} tag exceeds character limit for companies",
      "TAG_CANNOT_BE_EMPTY": "{{label}} tag cannot be empty for companies",
      "INVALID_EMAIL": "{{label}} has invalid email format for companies",
      "INVALID_CURRENCY_CODE": "{{label}} has invalid currency code for companies",
      "PHONE_NATIONAL_NUMBER_EXCEEDS_LIMIT": "{{label}} phone number exceeds character limit for companies",
      "PHONE_COUNTRY_CODE_EXCEEDS_LIMIT": "{{label}} country code exceeds character limit for companies",
      "PHONE_EXTENSION_EXCEEDS_LIMIT": "{{label}} phone extension exceeds character limit for companies",
      "STRING_EXCEEDS_LIMIT": "{{label}} exceeds character limit for companies",
      "STRING_LIST_ITEM_EXCEEDS_LIMIT": "{{label}} list item exceeds character limit for companies",
      "INVALID_URL": "{{label}} has invalid URL format for companies",
      "GEOPOINT_LATITUDE_OUT_OF_RANGE": "{{label}} latitude must be between -90 and 90 degrees for companies",
      "GEOPOINT_LONGITUDE_OUT_OF_RANGE": "{{label}} longitude must be between -180 and 180 degrees for companies",
      "NOT_A_NUMBER": "{{label}} must be a number for companies",
      "NOT_A_WHOLE_NUMBER": "{{label}} must be a whole number for companies",
      "NOT_A_DATE": "{{label}} must be a date for companies",
      "NOT_A_DATETIME": "{{label}} must be a date and time for companies",
      "NOT_A_BOOLEAN": "{{label}} must be true or false for companies",
      "NOT_A_CURRENCY_AMOUNT": "{{label}} must be a currency amount for companies",
      "NOT_A_GEOPOINT": "{{label}} must be a latitude and longitude for companies",
      "NOT_A_PHONE_NUMBER": "{{label}} must be a valid phone number for companies",
      "RESTRICTED_VALUE_WITH_OPTIONS": "\"{{value}}\" is not one of the options for the company field \"{{label}}\". Change it to one of: {{acceptedValues}}"
    },
    "SELECT_MODAL": {
      "ONE_SELECTED": "Add company",
      "MORE_SELECTED": "Add {{totalSelected}} companies",
      "NO_SELECTED": "Please select a company",
      "CREATE_NEW": "Create new company"
    },
    "SELECT_FIELD": "Select a company field"
  },
  "TASK": {
    "TITLE": "Tasks",
    "ADD_OBJECT_BUTTON": "Create task",
    "VIEW_OBJECT": "View task",
    "RECORD_CHANGE_ACTIVITY": {
      "CREATED": "Task created",
      "CREATED_VIA": "Task created via"
    },
    "SELECT_MODAL": {
      "ONE_SELECTED": "Add task",
      "MORE_SELECTED": "Add {{totalSelected}} tasks",
      "NO_SELECTED": "Please select a task",
      "CREATE_NEW": "Create new task"
    },
    "CREATE_PAGE": {
      "TITLE": "Create task",
      "SAVE": {
        "SUCCESS": "Task creation was successful",
        "ERROR": "Something went wrong"
      },
      "LOAD": {
        "ERROR": "Something went wrong"
      }
    },
    "EDIT_PAGE": {
      "TITLE": "Edit task",
      "SAVE": {
        "SUCCESS": "Task was updated successfully"
      }
    },
    "LIST_OBJECTS_TABLE": {
      "EMPTY_TABLE": {
        "IMAGE_ALT": "Graphic showing a task to be filled in",
        "HEADER": "Create your first task",
        "HINT": "Track, manage and complete your daily tasks"
      },
      "ACTIONS": {
        "EDIT": {
          "TITLE": "Edit task",
          "ERROR_LOADING_TASK": "Failed to load resource. Contact your administrator."
        },
        "DELETE": {
          "ACTION": "Delete task",
          "TITLE": "Delete {{ name }}?",
          "CONFIRMATION_MESSAGE": "This cannot be undone.",
          "CONFIRMATION_TEXT": "DELETE",
          "INSTRUCTIONS": "Type DELETE to confirm.",
          "CONFIRM": "Delete",
          "CANCEL": "Cancel",
          "SUCCESS": "Deleted task",
          "ERROR": "Error deleting task"
        },
        "DELETE_SELECTED": {
          "ACTION": "Delete tasks",
          "TITLE": "Delete tasks?",
          "CONFIRMATION_MESSAGE": "This cannot be undone.",
          "CONFIRMATION_TEXT": "DELETE",
          "INSTRUCTIONS": "Type DELETE to confirm.",
          "CONFIRM": "Delete",
          "CANCEL": "Cancel",
          "SUCCESS": "Deleted tasks",
          "ERROR": "Error deleting tasks"
        },
        "CREATE": {
          "TITLE": "Create task"
        },
        "TASK_QUEUE": {
          "START_TASKS": "Start tasks",
          "START_TASK": "Start task",
          "START_COUNT": "Start {{count}} task(s)",
          "NO_TASKS_SELECTED": "No tasks selected to start working on",
          "ASSOCIATIONS_CHIP": "{{count}} associations"
        },
        "COMPLETE": {
          "SINGLE": {
            "TITLE": "Complete task",
            "SUCCESS": "Task completed",
            "ERROR": "Error completing task"
          },
          "PLURAL": {
            "TITLE": "Complete tasks",
            "SUCCESS": "Tasks completed",
            "ERROR": "Error completing {{ amount }} or {{ total }} tasks"
          }
        }
      },
      "CUSTOM_COLUMNS": {
        "ASSIGNED_TO": "Assigned to",
        "DAYS_OVERDUE": "Overdue {{ amount }} days",
        "HOURS_OVERDUE": "Overdue {{ amount }} hours",
        "ASSOCIATED_COMPANY": "Company",
        "ASSOCIATED_CONTACT": "Contact"
      },
      "PIPELINE": {
        "EMPTY_STATE": {
          "TITLE": "Set up your pipeline and create your first task",
          "MESSAGE": "Start with a default pipeline, or create a custom pipeline that matches your sales process",
          "SETUP_PIPELINE": "Set up pipeline"
        }
      }
    },
    "TABLE_FILTERS": {
      "HEADER": "Tasks"
    },
    "STATUS_UPDATE": {
      "SUCCESS": "Task status updated",
      "ERROR": "Task status update failed"
    },
    "PERMISSION_DIALOG": {
      "TITLE": "Permission Required",
      "NO_ACCESS_MESSAGE": "You don't have permission to access {{inaccessibleCount}} of {{totalCount}} tasks",
      "CONTINUE_QUESTION": "Do you want to continue with the accessible tasks?"
    }
  },
  "LIST_OBJECTS_TABLE": {
    "CUSTOM_COLUMNS": {
      "FULL_ADDRESS": "Address"
    },
    "ACTIONS": {
      "DELETE": {
        "MODAL_TITLE": "Delete {{name}}?",
        "INSTRUCTIONS": "Type DELETE to confirm.",
        "CONFIRMATION_TEXT": "DELETE"
      },
      "DELETE_SELECTED": {
        "INSTRUCTIONS": "Type DELETE to confirm.",
        "CONFIRMATION_TEXT": "DELETE"
      }
    },
    "ACTIONS_COLUMN": {
      "TITLE": "Actions"
    },
    "CREATED_COLUMN": {
      "TITLE": "Created"
    },
    "DATE_DEFAULT": {
      "INVALID": "Exact date",
      "TODAY": "Today",
      "YESTERDAY": "Yesterday",
      "TOMORROW": "Tomorrow",
      "THIS_WEEK": "This week",
      "LAST_WEEK": "Last week",
      "NEXT_WEEK": "Next week",
      "THIS_MONTH": "This month",
      "LAST_MONTH": "Last month",
      "NEXT_MONTH": "Next month",
      "THIS_QUARTER": "This quarter",
      "LAST_QUARTER": "Last quarter",
      "NEXT_QUARTER": "Next quarter",
      "THIS_YEAR": "This year",
      "LAST_YEAR": "Last year",
      "NEXT_YEAR": "Next year"
    },
    "EXTERNAL_ID_COLUMN": {
      "TITLE": "External ID"
    },
    "ID_COLUMN": {
      "TITLE": "ID"
    },
    "UPDATED_COLUMN": {
      "TITLE": "Updated"
    },
    "STANDARD_FIELD_RULES": {
      "UNIQUE_FIELD_VALUE": {
        "ENFORCED": "A company with this {{label}} already exists",
        "WARNING": "One or more companies with this {{label}} already exists"
      }
    },
    "BULK_DELETE": {
      "LABEL": "Bulk delete",
      "INSTRUCTIONS": "This action may take a while to complete. Type DELETE to confirm.",
      "CONFIRMATION_TEXT": "DELETE"
    },
    "TIMER_CELL": {
      "TIME_LEFT": "{{time}} left",
      "OVERDUE": "{{time}} overdue",
      "PAUSED": "Paused",
      "NOT_STARTED": "Not started",
      "EXPIRED": "Expired",
      "STOPPED": "Stopped",
      "TERMINATED": "Terminated"
    }
  },
  "VIEW_TABS": {
    "EDIT_TABS": "Edit views",
    "NEW_VIEW": "New view",
    "HINT": "Organise your workspace by showing, hiding, renaming or creating new pre-saved views. New views will be made based on your currently applied filters.",
    "CUSTOM_VIEWS_TAB_GROUP": "Custom views",
    "DEFAULT_VIEWS_TAB_GROUP": "Default views",
    "ADD_TAB": "+ New view with current filters",
    "ERRORS": {
      "NAME_REQUIRED": "Changes cannot be saved as one or more view is missing a name",
      "FAILED_TO_SAVE_DEFAULT_VIEWS": "Failed to save changes to default views",
      "FAILED_TO_SAVE_CUSTOM_VIEWS": "Failed to save changes to custom views",
      "FAILED_TO_SAVE_VIEW_ORDER": "Failed to save changes to view order",
      "PARTIAL_FAIL_TO_SAVE_CUSTOM_VIEWS": "Failed to save some changes to view order",
      "FAILED_TO_DELETE_CUSTOM_VIEWS": "Failed to delete custom views",
      "PARTIAL_FAIL_TO_DELETE_CUSTOM_VIEWS": "Failed to delete some custom views"
    },
    "SUCCESS": {
      "SAVED_CUSTOM_VIEWS": "Custom views saved. If changes don't appear, please refresh the page."
    }
  },
  "OBJECT_WORKSPACE": {
    "CLOSE_TAB": "Close tab",
    "HIDE_VIEWS": "Hide views",
    "SHOW_VIEWS": "Show views",
    "UNTITLED": "Untitled"
  },
  "CRM_FORM_SERVICE": {
    "RESOURCE_NOT_FOUND_ERROR": "Resource not found"
  },
  "STANDARD_FIELD_GROUPS": {
    "CONTACT": {
      "BASIC_INFORMATION": "Basic information",
      "BASIC_GROUP2_INFORMATION": "Primary location",
      "BASIC_GROUP3_INFORMATION": "About contact",
      "COMMUNICATION_CONSENT": "Communication consent"
    },
    "COMPANY": {
      "BASIC_INFORMATION": "Basic information",
      "ADDITIONAL_INFORMATION": "Additional information"
    },
    "OPPORTUNITY": {
      "BASIC_INFORMATION": "Basic information",
      "ADDITIONAL_INFORMATION": "Additional information"
    },
    "CUSTOM_FIELDS": "Custom fields"
  },
  "STANDARD_FIELD_RULES": {
    "CONTACT": {
      "FIRST_OR_LAST_NAME_OR_PHONE_OR_EMAIL_REQUIRED": "One of first name, last name, phone or email is required"
    },
    "COMPANY": {
      "COMPANY_NAME_REQUIRED": "Company name is required",
      "TAG_LIMIT": "A maximum of 25 tags can be selected",
      "CATEGORY_LIMIT": "A maximum of 10 categories can be selected"
    },
    "OPPORTUNITY": {
      "OPPORTUNITY_NAME_REQUIRED": "Opportunity name is required",
      "OPPORTUNITY_PIPELINE_ID_REQUIRED": "Opportunity pipeline is required",
      "STAGE_REQUIRED": "Stage is required",
      "OPPORTUNITY_STATUS_REQUIRED": "Opportunity status is required"
    },
    "CUSTOM_OBJECT": {
      "CUSTOM_OBJECT_NAME_REQUIRED": "{{ customObjectName }} name is required"
    }
  },
  "PAGE_NOT_FOUND": {
    "HEADER": "404 Not Found",
    "HINT": "The page or information requested could not be found."
  },
  "BULK_IMPORT": {
    "TITLE": "Bulk import",
    "UPLOAD_CSV_STEP": {
      "TITLE": "Upload CSV",
      "INSTRUCTIONS": "Upload an existing CSV of customer data.",
      "REQUIREMENTS": {
        "CONTACT": "A first name, last name, phone number <strong>OR</strong> email must be included for each contact.",
        "CONTACT_NAME_SPLIT": "Contact names are stored as two fields, <strong>First name</strong> and <strong>Last name</strong>. Your CSV needs them as separate columns.",
        "COMPANY": "A name must be selected for each company.",
        "OPPORTUNITY": "Opportunities require a <strong>Name</strong>, <strong>Pipeline</strong>, and <strong>Probability</strong>, and must be associated with at least one Contact or Company.",
        "OPPORTUNITY_NO_PIPELINES": "To import opportunities, first create an opportunity pipeline in pipeline settings. Opportunities require a <strong>Name</strong>, <strong>Pipeline</strong>, and <strong>Probability</strong>.",
        "UNIQUE_HEADER_NAMES": "Each column header must be unique.",
        "SALESPERSON_MAPPING": "Salesperson emails can be mapped to Salesperson ID for contacts and companies.",
        "PHONE_NUMBER_RECOMMENDATION": "When uploading phone numbers outside of the US, specify the country name in a separate column.",
        "FILE_EXPIRATION": "For your security, uploaded files and any error files generated during import are automatically deleted after 30 days."
      },
      "MAXIMUM_FILE_SIZE": "Maximum File Size: 10MB",
      "REQUIRED": "This field is required",
      "SUCCESSFUL_UPLOAD": "Successfully uploaded {{filename}}",
      "AVAILABLE_FILES": "Available files :",
      "DOWNLOAD_CSV_TEMPLATE": "Download CSV template",
      "DOWNLOAD_OPPORTUNITY_CSV_TEMPLATE": "Download opportunity CSV template",
      "DOWNLOAD_LIST_OF_BUSINESS_CATEGORIES": "Download list of business categories",
      "REFERENCE_GUIDE_TITLE": "Reference IDs & mapping guide",
      "NO_PIPELINES_TIP": "To import opportunities, first create an opportunity pipeline in pipeline settings.",
      "PIPELINE_LOOKUP_LABEL": "Pipeline",
      "PIPELINE_ID_LABEL": "Pipeline ID",
      "COPY_PIPELINE_ID": "Copy pipeline ID",
      "STATUSES_LABEL": "Statuses",
      "STAGE_PROBABILITY_MAP_LABEL": "Stage probability map",
      "PROBABILITY_FORMAT_HINT": "Enter probability as a decimal between 0 and 1 (e.g. 0.1 = 10%, 0.5 = 50%, 1 = 100%).",
      "STAGE_MAP": {
        "STAGE": "Stage",
        "STATUS": "Status",
        "PROBABILITY": "Probability"
      },
      "EXAMPLE_CSV_ROW_LABEL": "Example opportunity CSV",
      "DOWNLOAD_EXAMPLE_OPPORTUNITY_CSV": "Download example opportunity CSV",
      "SELECT_PIPELINE_FIRST": "Please select a pipeline first",
      "PARSE_ERROR": "Failed to process the CSV file. Please try again.",
      "EXAMPLE_CSV": {
        "COMPANY_NAME": "Company name",
        "OPPORTUNITY_NAME": "Opportunity name",
        "PIPELINE": "Pipeline",
        "PIPELINE_ID": "Pipeline ID",
        "PROBABILITY": "Probability",
        "HINT": "Map exactly as shown in your CSV headers and rows. Required fields highlighted."
      }
    },
    "MAP_FIELDS_STEP": {
      "TITLE": "Map fields",
      "INSTRUCTIONS": "Confirm that the columns in your file map to the correct fields. A name, phone number <strong>OR</strong> email must be selected for contacts. A name must be selected for companies.",
      "PARTNER_INSTRUCTIONS": "Salesperson emails can be mapped to Salesperson ID for contacts and companies.",
      "COLUMN_HEADER": "Column header",
      "PREVIEW": "Preview",
      "IMPORT_AS": "Import as",
      "MAP_TO": "Map to",
      "ARIA_LABEL": "Map to fields",
      "OTHER_FIELDS": "Other fields",
      "DO_NOT_IMPORT": "Do not import",
      "REQUIRED": "Mapping a name, phone number OR email is required to proceed",
      "UNABLE_TO_MAP_FIELD": "{{fieldName}} is already mapped to {{header}}",
      "NO_IMPORT_TYPES_SELECTED": "Please select an import type",
      "NO_MAPPINGS_SELECTED": "Please map at least one field to proceed",
      "LOADING_FIELDS": "Loading the fields you can map to…",
      "VALIDATING": "Checking your mapping…",
      "REVIEW_FILE_ERRORS": "Please review the errors in your file before continuing",
      "PARTIAL_CHECK_NOTE": "Only the first few rows are checked here. The whole file is checked during the import, and anything wrong is listed in the error report.",
      "DUPLICATE_HEADER_NAME": "Duplicate header",
      "DUPLICATE_HEADER_NAME_DESCRIPTION": "This column header was detected more than once in your file. You are still able to import, but only the first occurrence of this header in your file will be used. Please ensure that each column header is unique.",
      "OPPORTUNITY_NO_ASSOCIATION": "Opportunity has no associated Contact, Company or Custom Object.",
      "SELECT_A_FIELD": "Select a field to map",
      "UNMAPPED_FIELDS_CALLOUT": "Some columns weren't automatically mapped. Select a destination field for each row you want to import, or leave it blank to skip it.",
      "METADATA_LOAD_FAILED": "We couldn't load the fields to map to. Retry to load them again.",
      "ROW_WARNINGS_TITLE": "Possible issues ({{count}})",
      "ROW_LABEL": "Row {{row}}:"
    },
    "REVIEW_IMPORT_STEP": {
      "TITLE": "Review import",
      "INSTRUCTIONS": "Importing this will take several minutes depending on the number of customers you are creating.",
      "ESTIMATED_TOTAL": "an estimated total of ",
      "ADDING_CUSTOMERS_FROM_FILENAME": "Adding {{estimatedText}}{{rows}} customers from {{csvFilename}}.",
      "UPDATE_DUPLICATES": "Update existing customers",
      "UPDATE_DUPLICATES_INSTRUCTIONS": "Check this box to update duplicates with new information. Duplicates are identified using ID and external ID for both companies and contacts, email address for contacts, and company name for companies. If left unchecked, all duplicates will be skipped.",
      "UPDATE_DUPLICATES_TOOLTIP": "If this is not selected, existing contacts will be skipped. This will detect duplicates based on the ID field, external ID field, and fields marked unique like email."
    },
    "IMPORT_SUCCESS": "Started import for {{filename}}",
    "IMPORT_ERROR": "Uh-oh. Looks like something went wrong on our end. Please try again."
  },
  "FILE_MANAGEMENT": {
    "TITLE": "File management",
    "BREADCRUMB_ROOT": "Home",
    "LOADING": "Loading…",
    "PERMISSION_REQUIRED": {
      "TITLE": "Permission required",
      "MESSAGE": "You don't have access to file management for this partner."
    },
    "COLUMNS": {
      "NAME": "Name",
      "SIZE": "Size",
      "TYPE": "Type",
      "SHARED_WITH": "Shared with",
      "CREATED": "Created",
      "UPDATED": "Updated",
      "PATH": "Path",
      "DESCRIPTION": "Description",
      "SOURCE": "Source",
      "TAGS": "Tags"
    },
    "SOURCES": {
      "UPLOADED": "Uploaded",
      "EMAIL": "Email",
      "CONVERSATIONS": "Conversations"
    },
    "EMPTY_STATE": {
      "TITLE": "No files here yet",
      "MESSAGE": "Upload a file, or drag and drop one onto this page.",
      "FILTERED_TITLE": "No files match your filters",
      "FILTERED_MESSAGE": "Try a different search term or clear your filters."
    },
    "DRAG_DROP": {
      "OVERLAY": "Drop files here to upload"
    },
    "SHARED_WITH": {
      "PUBLIC": "Public",
      "NAMESPACE": "All of {{name}}",
      "NAMESPACE_FALLBACK": "Organization",
      "USER": "1 person",
      "USERS": "{{count}} people",
      "ACCOUNT_GROUP": "1 account group",
      "ACCOUNT_GROUPS": "{{count}} account groups",
      "GROUP": "1 group",
      "GROUPS": "{{count}} groups",
      "PARTNER": "1 partner",
      "PARTNERS": "{{count}} partners",
      "TOOLTIP_PUBLIC": "Anyone with the link can view",
      "TOOLTIP_NAMESPACE": "Anyone at {{name}} can view",
      "TOOLTIP_NAMESPACE_FALLBACK": "Anyone in this organization can view"
    },
    "ACTIONS": {
      "DOWNLOAD": "Download",
      "RENAME": "Rename",
      "DELETE": "Delete",
      "MENU_LABEL": "File actions",
      "MANAGE_TAGS": "Manage tags",
      "UPLOAD": "Upload",
      "NEW_FOLDER": "New folder",
      "MANAGE_SHARING": "Manage sharing"
    },
    "RENAME": {
      "TITLE": "Rename file",
      "INPUT_LABEL": "File name",
      "PLACEHOLDER": "Enter file name",
      "SAVE": "Save",
      "CANCEL": "Cancel",
      "SUCCESS": "File renamed",
      "ERROR": "Couldn't rename file. Something went wrong while renaming \"{{fileName}}\". Please try again."
    },
    "ARIA": {
      "BREADCRUMB": "Folder path"
    },
    "DELETE_CONFIRMATION": {
      "TITLE": "Delete file?",
      "MESSAGE": "Are you sure you want to delete \"{{fileName}}\"? This cannot be undone.",
      "CONFIRM": "Delete",
      "CANCEL": "Cancel"
    },
    "SHARED_WITH_FILTER": {
      "PUBLIC": "Public",
      "NAMESPACE": "Everyone in this organization",
      "USER": "Shared with individuals",
      "ACCOUNT_GROUP": "Account groups",
      "GROUP": "Groups",
      "PARTNER": "Partners"
    },
    "SNACKBAR": {
      "LOAD_ERROR": "Failed to load files",
      "DELETE_ERROR": "Could not delete file",
      "DELETE_SUCCESS": "Deleted {{fileName}}",
      "TOTAL_SIZE_LIMIT": "Upload limit reached - total upload size must not exceed 5 GB",
      "IMAGE_SIZE_LIMIT": "Upload limit reached - each image must not exceed 10 MB",
      "VIDEO_SIZE_LIMIT": "Upload limit reached - each video must not exceed 1 GB",
      "NOTHING_TO_UPLOAD": "No files to upload",
      "UPLOAD_SUMMARY_SUCCESS": "{{count}} file(s) uploaded successfully",
      "UPLOAD_SUMMARY_PARTIAL": "{{uploaded}} succeeded, {{failed}} failed"
    },
    "UPLOAD": {
      "FILE": "Upload file",
      "FOLDER": "Upload folder"
    },
    "UPLOAD_DIALOG": {
      "TITLE": "Uploading files",
      "TITLE_FAILED": "Upload finished with errors",
      "PROGRESS": "Uploading {{completed}} of {{total}}…",
      "NEEDS_ATTENTION": "{{failed}} file(s) need attention",
      "CLOSE": "Close"
    },
    "CREATE_FOLDER": {
      "TITLE": "New folder",
      "INPUT_LABEL": "Folder name",
      "PLACEHOLDER": "Enter folder name",
      "DUPLICATE_ERROR": "A folder with this name already exists. Please choose a different name.",
      "CANCEL": "Cancel",
      "CREATE": "Create"
    },
    "FILE_TYPES": {
      "IMAGE": "Image",
      "VIDEO": "Video",
      "PDF": "PDF",
      "SPREADSHEET": "Spreadsheet",
      "PRESENTATION": "Presentation",
      "DOCUMENT": "Document",
      "ARCHIVE": "Archive",
      "FILE": "File"
    },
    "FILTERS": {
      "ADD_HEADER": "Filter files"
    },
    "PICKER": {
      "TITLE": "Add from my files",
      "CANCEL": "Cancel",
      "EMPTY_MESSAGE": "No media files here yet."
    },
    "MANAGE_TAGS": {
      "TITLE": "Tags for \"{{fileName}}\"",
      "ADD_PLACEHOLDER": "Add a tag and press Enter",
      "REMOVE": "Remove tag",
      "SAVE": "Save",
      "CANCEL": "Cancel",
      "SUCCESS": "Tags updated",
      "ERROR": "Could not update tags"
    },
    "GRID": {
      "SEARCH": "Search files...",
      "NO_RESULTS": "No files found",
      "LOAD_ERROR": "Could not load files",
      "BREADCRUMB_ROOT": "All files",
      "LOAD_MORE": "Load more"
    },
    "MANAGE_SHARING": {
      "TITLE": "Sharing for \"{{fileName}}\"",
      "ACTIVE_HEADING": "Temporary links",
      "LOADING": "Loading links…",
      "NONE": "No active links.",
      "EXPIRES": "Expires {{date}}",
      "REVOKE": "Revoke",
      "REVOKE_SUCCESS": "Share link revoked",
      "REVOKE_ERROR": "Could not revoke the share link",
      "LOAD_ERROR": "Could not load share links",
      "TRUNCATED": "Only the first {{count}} links are shown. Revoke any you no longer need.",
      "CREATE_HEADING": "Create a link",
      "LABEL_LABEL": "Who is this for?",
      "LABEL_PLACEHOLDER": "e.g. bob@acme.com",
      "LABEL_HINT": "Optional. Shown in the list above so you can tell your links apart.",
      "DURATION_LABEL": "Link expires after",
      "DURATION_DAY": "1 day",
      "DURATION_DAYS": "{{count}} days",
      "CREATE": "Create link",
      "CREATE_ERROR": "Could not create the share link",
      "COPY_NOW": "Copy this link now — it won't be shown again.",
      "COPY": "Copy link",
      "COPIED": "Copied",
      "DONE": "Done",
      "INDICATOR_ONE": "1 active share link, expires {{date}}",
      "INDICATOR_MANY": "{{count}} active share links, next expires {{date}}",
      "ACCESS_HINT": "Anyone with the link can open this file until it expires.",
      "NEW_LINK_LABEL": "Your share link",
      "INDICATOR_ONE_NO_DATE": "1 active share link",
      "INDICATOR_MANY_NO_DATE": "{{count}} active share links",
      "AUDIENCE_HEADING": "Who can view this file",
      "PUBLIC_LABEL": "Anyone with the file's URL can view — never expires",
      "PUBLIC_WARNING": "Anyone who has the URL keeps access until you turn this off.",
      "PUBLIC_CONFIRM_TITLE": "Let anyone with the link view this file?",
      "PUBLIC_CONFIRM_MESSAGE": "Anyone with the file's URL can view it without signing in. You can turn this off at any time.",
      "PUBLIC_CONFIRM_BUTTON": "Make public",
      "PUBLIC_CONFIRM_CANCEL": "Cancel",
      "PUBLIC_ON_SUCCESS": "Anyone with the link can now view this file",
      "PUBLIC_OFF_SUCCESS": "Public access turned off",
      "PUBLIC_ERROR": "Could not update who can view this file"
    }
  },
  "IMPORTER": {
    "TITLE": "Import",
    "LIST_OBJECTS_TABLE": {
      "COLUMNS": {
        "NAME": "Name",
        "STATUS": "Status",
        "PROCESSED": "Processed",
        "SKIPPED": "Skipped",
        "ERRORS": "Errors",
        "IMPORT_DATE": "Import date"
      },
      "ACTIONS": {
        "DOWNLOAD_ORIGINAL_CSV": "Download original file",
        "DOWNLOAD_ERROR_CSV": "Download error file"
      },
      "FILE_EXPIRED_TITLE": "File Not Available",
      "FILE_EXPIRED": "This file is no longer available for download. Uploaded files and any error files generated during import are automatically deleted after 30 days for your security."
    },
    "BULK_ACTIONS": {
      "TOOLTIP": {
        "TITLE": "Import from a CSV",
        "DESCRIPTION": "Upload your existing list of companies or contacts using a spreadsheet. For your security, uploaded files and any error files generated during import are automatically deleted after 30 days.",
        "ACTION": "Start an import"
      }
    },
    "STATUS_BADGE": {
      "IN_PROGRESS": "In progress",
      "COMPLETE": "Complete",
      "COMPLETED_WITH_ERRORS": "Complete with errors",
      "FAILED": "Failed"
    },
    "BULK_ACTIONS_IMAGE_ALT": "Illustration of a spreadsheet being imported",
    "LEGACY_MIGRATION": {
      "MESSAGE": "Don't see your import here?",
      "LINK": "View the legacy importer"
    }
  },
  "TABLE_FILTERS": {
    "ADD_FILTER": "Add filter",
    "CLEAR_FILTERS": "Clear all",
    "FIND_FILTER": "Find filter",
    "INVALID_FILTER_TYPE": "Filter type is invalid",
    "INCOMPLETE_FILTER": "Filter is incomplete. Complete the filter before applying it.",
    "SELECT_OPERATOR_PLACEHOLDER": "Select operator...",
    "SELECT_EXPRESSION_PLACEHOLDER": "Select...",
    "SELECT_START_PLACEHOLDER": "Start date",
    "SELECT_END_PLACEHOLDER": "End date"
  },
  "MODEL_DRIVEN_FORM": {
    "LOADING_STATUS_ERROR": {
      "TITLE": "Something went wrong",
      "TEXT": "Please wait a few moments and try again. If the problem persists, please contact an administrator"
    },
    "STRING_LIMIT_HINT": "Maximum {{characters}} characters",
    "TAG_LIMIT_ERROR": "Only {{maximumTags}} tags are allowed",
    "INVALID_DROPDOWN_ERROR": "Select a valid option",
    "SUBMITTED_PRISTINE": "You have not made any changes.",
    "SECTION_HAS_ERRORS": "This section has fields with errors",
    "SUBMITTED_WITH_ERROR": "Failed to create object. Please ensure that fields are filled out correctly.",
    "CREATE_ERROR": "Failed to create {{objectType}}. Please ensure that fields are filled out correctly.",
    "UPDATE_ERROR": "Failed to update {{objectType}}. Please ensure that fields are filled out correctly.",
    "INVALID_EMAIL_ERROR": "Email entered is invalid",
    "INVALID_EMAIL_LIST_ERROR": "One or more email addresses are invalid",
    "ADD_TAG_PROMPT": "Add a tag...",
    "ADD_STRINGLIST_ITEM_PROMPT": "Add an item...",
    "ADD_EMAIL_PROMPT": "Add an email address...",
    "NO_EMAILS_ADDED": "No email addresses added",
    "MAX_EMAILS_REACHED": "Maximum number of email addresses reached ({{maxEmails}})",
    "SELECT_PROMPT": "Select...",
    "INVALID_URL_ERROR": "URL entered is invalid",
    "PHONE": {
      "INVALID_PHONE_ERROR": "Phone number entered is invalid",
      "COUNTRY_LABEL": "Area code",
      "EXTENSION_LABEL": "Extension",
      "SEARCH_COUNTRY_LABEL": "Search",
      "SEARCH_COUNTRY_NO_RESULTS": "No results found"
    },
    "BOOLEAN": {
      "TRUE": "Yes",
      "FALSE": "No"
    },
    "MARKETING_CONSENT": {
      "SUBSCRIBED": "Subscribed",
      "UNSUBSCRIBED": "Unsubscribed",
      "UNSET": "Unset"
    },
    "ADD_FIELD_VALUE": "Add {{fieldName}}...",
    "EDIT_FIELD": "Edit field",
    "OTHER_OPTIONS": "Other options",
    "SEARCH_ALL_FIELDS": "Search fields",
    "NO_MATCHING_FIELDS": "No fields match “{{term}}”"
  },
  "COLLAPSIBLE_SECTION": {
    "VIEW_MORE": "View more",
    "VIEW_LESS": "View less"
  },
  "PERMISSION": {
    "TITLE": "Permission required",
    "DESCRIPTION": "You don't have the necessary permissions to view this page.",
    "REQUEST_ACCESS": "Request access from your administrator.",
    "PREV_PAGE": "Back to previous page",
    "HOME_PAGE": "Go to home page",
    "IMAGE_ALT": "Graphic showing denied access due to permissions"
  },
  "CAMPAIGNS": {
    "TITLE": "Campaigns",
    "NO_CAMPAIGNS": "No email campaigns have been started for this account",
    "DELETED_CAMPAIGN": "Deleted Campaign",
    "CONTACTS": {
      "MODAL": {
        "SELECT_ALL_SUCCESS": "{{ totalObjects }} contacts added to campaign: {{ campaignTitle }}",
        "ID": "ID",
        "NAME": "Name",
        "EMAIL": "Email",
        "NO_CAMPAIGNS": "No campaigns found",
        "PUBLISH": "Publish now",
        "BACK": "Back",
        "START_CAMPAIGN": "Start campaign",
        "CANCEL": "Cancel",
        "RECIPIENT_COUNT": "Estimated recipients: {{recipientCount}}",
        "UPDATED": "Last updated: ",
        "SELECT_CAMPAIGN": "Add {{recipientCount}} recipients to campaign",
        "MISSING_EMAIL_ADDRESS": "{{contactCount}} missing email addresses — ",
        "MISSING_EMAIL": "contacts without email addresses will not receive campaign emails.",
        "SEARCH_PLACEHOLDER": "Search active campaigns",
        "RECIPIENTS_TOOLTIP": "The recipient count is an estimate, as it doesn't account for contacts who have unsubscribed, are already on the campaign, or have invalid or missing email addresses.",
        "ERRORS": {
          "CAMPAIGN_CONFIGURATION_ERROR": "There was a problem with the campaign configuration. Please fix and try again.",
          "GENERIC_ERROR": "There was a problem starting the campaign. Please try again.",
          "FAILED_ADDRESS_ERROR": "'Failed to add the following addresses: '",
          "NO_CAMPAIGN_SELECTED": "Please select a campaign",
          "NO_VALID_CONTACTS_SELECTED": "Please select contacts with either an email or phone number",
          "NO_CONTACTS_SELECTED": "No contacts have been selected. Please select campaign recipients."
        },
        "SUCCESS": "recipients added to campaign: "
      }
    }
  },
  "DYNAMIC_LISTS": {
    "TITLE": "Lists",
    "EMPTY_STATE": {
      "EMPTY_PREVIEW": "Start building your list",
      "EMPTY_PREVIEW_DESCRIPTION": "Use filters to segment your customers. Results will appear here."
    },
    "MISC": {
      "AND": "AND"
    },
    "COLUMNS": {
      "ID": "ID",
      "NAME": "Name",
      "DESCRIPTION": "Description",
      "LIST_TYPE": "List type",
      "RESOURCE_TYPE": "Object type",
      "STATUS": "Status",
      "CREATED": "Created",
      "UPDATED": "Updated",
      "ACTIONS": "Actions"
    },
    "STATUS": {
      "READY": "Ready",
      "PROCESSING": "Processing",
      "FAILED": "Failed"
    },
    "ITEM_TABLE_COLUMNS": {
      "RESOURCE_ID": "ID",
      "RESOURCE_NAME": "Name",
      "RESOURCE_URL": "URL"
    },
    "LIST_TYPES": {
      "STATIC": "Static",
      "SMART": "Smart"
    },
    "FILTERS": "Filters",
    "PREVIEW": "Preview",
    "ESTIMATED_LIST_SIZE": "Estimated list size",
    "ESTIMATED_SIZE_INFINITY": "many",
    "ESTIMATED_SIZE_UNKNOWN": "-",
    "LIST_TYPES_DESCRIPTION": "Static lists are fixed. Customers must be added or removed manually. They're useful for organizing customers based on specific criteria. \n\nSmart lists automatically add or remove the customers within them based on the filters you set. They're useful for things like targeted campaigns or responding to real-time interactions.",
    "CREATE_MODAL": {
      "TITLE": "Create list",
      "FORM": {
        "RESOURCE_TYPE": "Object",
        "LIST_TYPE": "List type",
        "NAME": "Name",
        "NAME_PLACEHOLDER": "Add a name...",
        "NAME_REQUIRED": "Name is required",
        "DESCRIPTION": "Description",
        "DESCRIPTION_PLACEHOLDER": "Add a description..."
      }
    },
    "LIST_DETAILS_MODAL": {
      "TITLE": "Details"
    },
    "SELECT_LIST_MODAL": {
      "TITLE": "Add to static list",
      "SELECT_CONTACT_LIST_LABEL": "Add contacts to list:",
      "SELECT_COMPANY_LIST_LABEL": "Add companies to list:",
      "SELECT_CUSTOM_OBJECT_LIST_LABEL": "Add custom objects to list:",
      "SELECT_LIST_REQUIRED": "List is required",
      "SELECT_LIST_PLACEHOLDER": "Search lists",
      "AMOUNT_OF_SELECTED_COMPANIES": "<strong>{{amount}}</strong> companies selected",
      "AMOUNT_OF_SELECTED_CONTACTS": "<strong>{{amount}}</strong> contacts selected",
      "AMOUNT_OF_SELECTED_CUSTOM_OBJECTS": "<strong>{{amount}}</strong> custom objects selected"
    },
    "FILTERS_EDITOR": {
      "SELECT_FIELD": "Select a field"
    },
    "ERRORS": {
      "MISSING_LIST_NAME": "Please add a name to your list",
      "INVALID_LIST_TYPE": "Please select a valid list type for your list",
      "INVALID_RESOURCE_TYPE": "Please select a valid object type for your list",
      "EMPTY_FILTERS": "Please add at least one filter to the criteria",
      "INVALID_FIELD": "Please select a field for the filter",
      "INVALID_OPERATOR": "Please select an operator for the filter",
      "INVALID_VALUE": "Please add a value for the filter",
      "FAILED_TO_UPDATE": "Failed to update list",
      "FAILED_TO_ADD": "Failed to add to {{listName}}. Please try again.",
      "STILL_PROCESSING_1": "This list is processing",
      "STILL_PROCESSING_2": "Depending on the size of the list, it may take a while.",
      "STILL_PROCESSING_3": "Try checking back later, or refreshing the page.",
      "FAILED_TO_LOAD": "Failed to load the list to duplicate"
    },
    "PROCESSING": "Processing",
    "SUCCESS": {
      "CREATED": "List created successfully",
      "UPDATED": "List updated successfully",
      "ADDED_TO_LIST": "{{numberOfItems}} items added to {{listName}}",
      "ADDED_TO_LIST_SINGULAR": "{{numberOfItems}} item added to {{listName}}",
      "ADDING_TO_LIST": "{{numberOfItems}} items are being added to {{listName}}",
      "ADDING_TO_LIST_SINGULAR": "{{numberOfItems}} item is being added to {{listName}}"
    },
    "PENDING_CHANGES_MODAL": {
      "TITLE": "You have unsaved changes!",
      "MESSAGE": "Press 'Cancel' to go back and save these changes, or 'Proceed' to lose these changes.",
      "ACTIONS": {
        "PROCEED": "Proceed",
        "CANCEL": "Cancel"
      }
    },
    "ACTIONS": {
      "CREATE": "Create list",
      "EDIT": "Edit details",
      "DETAILS": "Details",
      "ADD_FILTER": "Add filter",
      "DELETE_FILTER": "Delete filter",
      "DELETE": "Delete",
      "DUPLICATE": "Duplicate list",
      "ADD": "Add",
      "ADD_TO_STATIC_LIST": "Add to static list",
      "REMOVE_ITEM": "Remove item",
      "START_AUTOMATION": "Start automation",
      "DELETE_CONFIRMATION": {
        "TITLE": "Delete list?",
        "MESSAGE": "This action cannot be undone.",
        "CONFIRM": "Delete",
        "CANCEL": "Cancel",
        "SUCCESS": "List deleted",
        "ERROR": "Error deleting list"
      },
      "ITEM_DELETE_CONFIRMATION": {
        "TITLE": "Remove item from list?",
        "MESSAGE": "This action cannot be undone.",
        "CONFIRM": "Remove item",
        "CANCEL": "Cancel",
        "SUCCESS": "Item removed from list",
        "ERROR": "Error removing item from list"
      },
      "CANNOT_EDIT": "Lists cannot be edited."
    }
  },
  "YESWARE": {
    "ACTIONS": {
      "ADD_TO_CAMPAIGN": "Add to Yesware campaign"
    },
    "ERRORS": {
      "FAILED_TO_ADD": "Failed to add to {{name}} campaign. Please try again.",
      "ALREADY_ON_CAMPAIGN_SINGULAR": "Contact is already active on a campaign, and cannot be added to {{name}} campaign",
      "ALREADY_ON_CAMPAIGN": "Contacts are already active on a campaign, and cannot be added to {{name}} campaign"
    },
    "SUCCESS": {
      "CREATED": "List created successfully",
      "UPDATED": "List updated successfully",
      "ADDED_TO_CAMPAIGN": "{{numberOfContacts}} contacts added to {{name}} campaign",
      "ADDED_TO_CAMPAIGN_SINGULAR": "{{numberOfContacts}} item added to {{name}} campaign",
      "ADDING_TO_CAMPAIGN": "{{numberOfContacts}} contacts are being added to {{name}} campaign",
      "ADDING_TO_CAMPAIGN_SINGULAR": "{{numberOfContacts}} contacts is being added to {{name}} campaign",
      "ADDED_TO_CAMPAIGN_PARTIAL": "{{successCount}} contacts added to {{name}} campaign. {{failedCount}} contacts failed to add to campaign."
    },
    "SELECT_YESWARE_CAMPAIGN_MODAL": {
      "TITLE": "Add to Yesware campaign",
      "SELECT_YESWARE_CAMPAIGN_LABEL": "Add contacts to Yesware campaign:",
      "SELECT_YESWARE_CAMPAIGN_REQUIRED": "Yesware campaign is required",
      "SELECT_YESWARE_CAMPAIGN_PLACEHOLDER": "Search Yesware campaigns",
      "AMOUNT_OF_SELECTED_COMPANIES": "<strong>{{amount}}</strong> companies selected",
      "AMOUNT_OF_SELECTED_CONTACTS": "<strong>{{amount}}</strong> contacts selected",
      "NO_CAMPAIGNS": "No Yesware campaigns found"
    }
  },
  "VIEWS": {
    "ACTIONS": {
      "CREATE_VIEW": "Create view"
    },
    "DELETE_CONFIRMATION": {
      "TITLE": "Delete view?",
      "MESSAGE": "{{ viewName }} will be deleted."
    },
    "EMPTY": "Add filters to create a view",
    "ERRORS": {
      "VIEW_NAME_REQUIRED": "View name is required",
      "EQUAL_TO_PRESET_NAME": "View name cannot be an existing name",
      "VIEW_NAME_TOO_LONG": "View name cannot be longer than 36 characters",
      "NO_FILTERS": "Add filters before creating a view"
    },
    "VIEW_NAME": "View name",
    "VIEWS": "Views",
    "PRESET_FILTERS": {
      "ALL": "All",
      "NOTES": "Notes",
      "TASKS": "Tasks",
      "EMAILS": "Emails",
      "CALLS": "Calls",
      "MEETINGS": "Meetings",
      "COMMUNICATIONS": "Communications",
      "EXCLUDE_CAMPAIGNS": "Exclude campaigns",
      "RECORDED_MEETINGS": "Recorded meetings"
    }
  },
  "LIFECYCLE_STAGE": {
    "VISITOR": "Visitor",
    "LEAD": "Lead",
    "MARKETING_QUALIFIED_LEAD": "Marketing qualified lead",
    "SALES_ACCEPTED_LEAD": "Sales accepted lead",
    "SALES_QUALIFIED_LEAD": "Sales qualified lead",
    "PROSPECT": "Prospect",
    "CUSTOMER": "Customer",
    "FORMER_CUSTOMER": "Former customer"
  },
  "TASK_QUEUE": {
    "ACTIONS": {
      "SKIP": "Skip",
      "MARK_AS_COMPLETE": "Mark as complete",
      "UNDO": "Undo",
      "NEXT": "Next",
      "BACK_TO_TASKS": "Back to tasks",
      "RESCHEDULE": "Reschedule"
    },
    "STATUS": {
      "COMPLETED": "Completed",
      "RESCHEDULED": "Rescheduled"
    },
    "TASKS": "Tasks",
    "RESCHEDULE_TASK": "Reschedule task",
    "ERRORS": {
      "MARK_AS_COMPLETE": "There was a problem marking the task as completey. Please try again.",
      "RESCHEDULE": "There was a problem rescheduling the task. Please try again.",
      "UNDO": "There was a problem updating the task. Please try again.",
      "INVALID_DUE_DATE": "Invalid due date"
    },
    "SUCCESS_MESSAGES": {
      "RESCHEDULE": "Task rescheduled"
    }
  },
  "SCORE_SETTINGS": {
    "TITLES": {
      "EDIT_SCORE": "Edit score",
      "POSITIVE": "Positive ({{ numberOfDefinitions }})",
      "NEGATIVE": "Negative ({{ numberOfDefinitions }})",
      "VIEW": {
        "POINTS": "Points: {{ points }}"
      },
      "EDIT": {
        "POINTS": "Points: {{ sign }}"
      }
    },
    "SUBTITLES": {
      "POSITIVE": "Add points to the total score when criteria has been met",
      "NEGATIVE": "Subtract points from the total score when criteria has been met"
    },
    "CTA": {
      "ADD_CRITERIA": "Add criteria",
      "ADD_FILTER": "Add filter"
    },
    "MISC": {
      "AND": "And",
      "UNSAVED_CHANGES": "Unsaved changes"
    },
    "EMPTY_STATE": {
      "FILTERS": "Add filters to this criteria",
      "PAGE": {
        "TITLE": "Create scoring rule",
        "SUBTITLE": "Set criteria to add and subtract points from the total score based on customer behaviour and fit or use our default set of criteria to categorize your leads",
        "CREATE_RULE_MYSELF": "Create rule myself",
        "CREATE_RULE_FOR_ME": "Create rule for me"
      }
    },
    "ERRORS": {
      "EMPTY_SCORING_DEFINITIONS": "Please add at least one criteria",
      "EMPTY_SCORING_RULES": "Please add at least one filter to the criteria",
      "INVALID_CONTRIBUTION": "Please add a valid contribuition to the criteria",
      "INVALID_FIELD": "Please select a field for the filter",
      "INVALID_OPERATOR": "Please select an operator for the filter",
      "INVALID_VALUE": "Please add a value for the filter",
      "FAILED_TO_UPDATE": "Failed to update scoring definitions"
    },
    "SUCCESS_MESSAGES": {
      "UPDATE": "Scoring definitions updated"
    }
  },
  "COMMON": {
    "YES": "yes",
    "NO": "no",
    "SNACKBAR_MESSAGE": {
      "COPY_SUCCESS": "Successfully copied to clipboard",
      "MEETING_EMAIL_SUCCESS": "Meeting request mail sent",
      "MEETING_EMAIL_FAILURE": "Failed to send meeting request mail",
      "NO_MEETING_TYPES": "At least one event type required to send a mail",
      "BULK_DELETE_SUCCESS": "Bulk delete initiated for {{count}} items. This may take a while.",
      "BULK_DELETE_FAILURE": "Failed to bulk delete items."
    }
  },
  "SYNC": {
    "TITLE": "Data syncing",
    "DESCRIPTION": "This data is automatically synced with the",
    "ACCOUNT": "associated account"
  },
  "OPPORTUNITY": {
    "TITLE": "Opportunities",
    "OBJECT_TYPE": "Opportunity",
    "STATUS": {
      "WON": "Won",
      "LOST": "Lost"
    },
    "ACTIONS": {
      "REOPEN": "Reopen",
      "CLOSE_WON": "Won",
      "CLOSE_LOST": "Lost",
      "CREATE_INVOICE": "Create invoice"
    },
    "CREATE_INVOICE": {
      "CURRENCY_MISMATCH": {
        "TITLE": "Currency mismatch",
        "BODY": "This opportunity's line items use multiple currencies ({{ found }}). Align them before creating an invoice."
      },
      "NO_CUSTOMER": "Add a contact or company to this opportunity before creating an invoice.",
      "MALFORMED_LINE_ITEMS": "One or more line items on this opportunity are missing required data. Edit the opportunity and try again."
    },
    "INVOICES": {
      "TITLE": "Invoices",
      "EMPTY": "No invoices yet",
      "DUE_DATE": "Due {{ date }}",
      "LOAD_ERROR": "Couldn't load invoices.",
      "RETRY": "Retry"
    },
    "ADD_OBJECT_BUTTON": "Create opportunity",
    "PROFILE_PAGE": {
      "TITLE": "Opportunity details",
      "EDIT": "Edit opportunity",
      "PREVIOUS_PAGE_TITLE": "Opportunities",
      "ACTIVITIES_TIMELINE_TAB": "Activity",
      "ABOUT_TAB": "About",
      "ASSOCIATIONS_TAB": "Associations",
      "CLOSE_LOST_MODAL": {
        "ACTION": "Close opportunity",
        "HINT": "This will close the opportunity with the current revenue and packages. The opportunity will no longer be editable.",
        "SELECT_PLACEHOLDER": "Select a reason",
        "NOTES_PLACEHOLDER": "Notes",
        "OPTIONS": {
          "PRICE": "Price",
          "NO_BUDGET": "No budget",
          "LOST_TO_COMPETITOR": "Lost to competitor",
          "NOT_READY": "Not ready",
          "OTHER": "Other"
        }
      }
    },
    "EDIT_PAGE": {
      "TITLE": "Edit opportunity",
      "SAVE": {
        "SUCCESS": "Opportunity was updated successfully",
        "FAIL": "Failed to update opportunity"
      }
    },
    "ASSOCIATION_PANEL": {
      "TITLE": "Opportunities",
      "ADD_ASSOCIATION": "Add opportunity",
      "CREATE_BUTTON": "Create and associate a new opportunity",
      "TITLE_ASSOCIATE": "Add opportunities to {{objectName}}",
      "VALUE": "Value",
      "ACTIVITY": "Last activity",
      "CLOSE_DATE": "Expected close date",
      "STAGE": "Stage",
      "STATUS": {
        "OPEN": "Open",
        "CLOSED_LOST": "Closed lost",
        "CLOSED_WON": "Closed won"
      }
    },
    "ASSOCIATION_FORM": {
      "TITLE": "Opportunities",
      "PLACEHOLDER": "Associate opportunity..."
    },
    "SELECT_MODAL": {
      "ONE_SELECTED": "Add opportunity",
      "MORE_SELECTED": "Add {{totalSelected}} opportunities",
      "NO_SELECTED": "Please select an opportunity",
      "CREATE_NEW": "Create new opportunity"
    },
    "LIST_OBJECTS_TABLE": {
      "CUSTOM_COLUMNS": {
        "PRIMARY_ASSOCIATIONS": "Primary association"
      },
      "EMPTY_TABLE": {
        "IMAGE_ALT": "Opportunities",
        "HEADER": "Create your first opportunity",
        "HINT": "Add an opportunity to track and manage your sales pipeline"
      },
      "ACTIONS": {
        "EDIT": {
          "TITLE": "Edit opportunity"
        },
        "DELETE": {
          "ACTION": "Delete opportunity",
          "TITLE": "Delete opportunity?",
          "CONFIRMATION_MESSAGE": "This cannot be undone.",
          "CONFIRMATION_TEXT": "DELETE",
          "INSTRUCTIONS": "Type DELETE to confirm.",
          "CONFIRM": "Delete",
          "CANCEL": "Cancel",
          "SUCCESS": "Deleted opportunity",
          "ERROR": "Error deleting opportunity"
        },
        "DELETE_SELECTED": {
          "ACTION": "Delete opportunities",
          "TITLE": "Delete opportunities?",
          "CONFIRMATION_MESSAGE": "This cannot be undone.",
          "CONFIRMATION_TEXT": "DELETE",
          "INSTRUCTIONS": "Type DELETE to confirm.",
          "CONFIRM": "Delete",
          "CANCEL": "Cancel",
          "SUCCESS": "Deleted opportunities",
          "ERROR": "Error deleting opportunities"
        },
        "CREATE": {
          "TITLE": "Create opportunity"
        }
      },
      "PIPELINE": {
        "EMPTY_STATE": {
          "TITLE": "Set up your pipeline and create your first opportunity",
          "MESSAGE": "Start with a default pipeline, or create a custom pipeline that matches your sales process",
          "SETUP_PIPELINE": "Set up pipeline"
        }
      },
      "FILTERS": {
        "STAGE": "Stage"
      }
    },
    "PIPELINE": {
      "SELECTOR": {
        "TITLE": "Select pipeline...",
        "NO_PIPELINES": "No pipelines",
        "EMPTY": "There are no pipelines yet. Please create a pipeline to continue.",
        "EMPTY_HINT": "No pipelines configured yet.",
        "CONFIGURE_LINK": "Configure pipelines"
      },
      "LAST_ACTIVITY": "Last activity",
      "EXPECTED_CLOSE_DATE": "Expected close date",
      "ACTUAL_CLOSE_DATE": "Close date",
      "PERCENTAGE_OF": "% of"
    },
    "STAGE": {
      "SELECTOR": {
        "LABEL": "Stage",
        "TITLE": "Select stage..."
      }
    },
    "TABLE_FILTERS": {
      "HEADER": "Opportunities"
    },
    "CREATE_PAGE": {
      "TITLE": "Create opportunity",
      "NAME_PLACEHOLDER": "Add opportunity name...",
      "SAVE": {
        "SUCCESS": "Opportunity creation was successful",
        "ERROR": "Something went wrong",
        "ASSOCIATIONS_REQUIRED": "Associate at least one company or contact"
      }
    },
    "RECORD_CHANGE_ACTIVITY": {
      "CREATED": "Opportunity created",
      "CREATED_VIA": "Opportunity created via",
      "DETAILS_UPDATED": "Opportunity details updated",
      "IMPORTANT_FIELD_UPDATED": "{{updatedField}} updated by"
    },
    "VALIDATION_ERROR": {
      "RESTRICTED_VALUE": "{{label}} value is not allowed for opportunities",
      "EMPTY_FIELD": "{{label}} cannot be empty for opportunities",
      "FIELD_WITHOUT_IDENTIFICATION": "{{label}} must have identification for opportunities",
      "DUPLICATE_FIELD_ID": "Duplicate {{label}} field detected for opportunity",
      "FIELD_DEFINITION_NOT_FOUND": "{{label}} field definition not found for opportunities",
      "UNSUPPORTED_FIELD_TYPE": "{{label}} field type is not supported for opportunities",
      "INVALID_VALUE_TYPE": "{{label}} has invalid value type for opportunities",
      "TAG_EXCEEDS_LIMIT": "{{label}} tag exceeds character limit for opportunities",
      "TAG_CANNOT_BE_EMPTY": "{{label}} tag cannot be empty for opportunities",
      "INVALID_EMAIL": "{{label}} has invalid email format for opportunities",
      "INVALID_CURRENCY_CODE": "{{label}} has invalid currency code for opportunities",
      "PHONE_NATIONAL_NUMBER_EXCEEDS_LIMIT": "{{label}} phone number exceeds character limit for opportunities",
      "PHONE_COUNTRY_CODE_EXCEEDS_LIMIT": "{{label}} country code exceeds character limit for opportunities",
      "PHONE_EXTENSION_EXCEEDS_LIMIT": "{{label}} phone extension exceeds character limit for opportunities",
      "STRING_EXCEEDS_LIMIT": "{{label}} exceeds character limit for opportunities",
      "STRING_LIST_ITEM_EXCEEDS_LIMIT": "{{label}} list item exceeds character limit for opportunities",
      "INVALID_URL": "{{label}} has invalid URL format for opportunities",
      "GEOPOINT_LATITUDE_OUT_OF_RANGE": "{{label}} latitude must be between -90 and 90 degrees for opportunities",
      "GEOPOINT_LONGITUDE_OUT_OF_RANGE": "{{label}} longitude must be between -180 and 180 degrees for opportunities",
      "NOT_A_NUMBER": "{{label}} must be a number for opportunities",
      "NOT_A_WHOLE_NUMBER": "{{label}} must be a whole number for opportunities",
      "NOT_A_DATE": "{{label}} must be a date for opportunities",
      "NOT_A_DATETIME": "{{label}} must be a date and time for opportunities",
      "NOT_A_BOOLEAN": "{{label}} must be true or false for opportunities",
      "NOT_A_CURRENCY_AMOUNT": "{{label}} must be a currency amount for opportunities",
      "NOT_A_GEOPOINT": "{{label}} must be a latitude and longitude for opportunities",
      "NOT_A_PHONE_NUMBER": "{{label}} must be a valid phone number for opportunities",
      "RESTRICTED_VALUE_WITH_OPTIONS": "\"{{value}}\" is not one of the options for the opportunity field \"{{label}}\". Change it to one of: {{acceptedValues}}"
    },
    "ACTIVITY": {
      "STATUS_RECORD_CHANGE": {
        "STATUS_LABEL": "Status",
        "REASON_LABEL": "Reason",
        "DESCRIPTION_LABEL": "Description"
      }
    },
    "STANDARD_FIELD_RULES": {
      "OPPORTUNITY": {
        "OPPORTUNITY_NAME_REQUIRED": "Opportunity name is required",
        "OPPORTUNITY_PIPELINE_ID_REQUIRED": "An opportunity needs a pipeline",
        "TAG_LIMIT": "An opportunity cannot have more than 25 tags"
      }
    }
  },
  "PIPELINES": {
    "TITLE": "Pipelines",
    "SETTINGS": {
      "TITLE": "Manage pipelines",
      "CTA": {
        "CREATE_PIPELINE": "Create pipeline",
        "DELETE_PIPELINE": "Delete pipeline",
        "ADD_STAGE": "Add stage"
      },
      "FORM": {
        "TITLES": {
          "PIPELINE_NAME": "Pipeline name",
          "PIPELINE_STAGES": "Pipeline stages",
          "STAGE_NAME": "Stage name",
          "CLOSE_PROBABILITY": "Close probability"
        },
        "SUBTITLES": {
          "PIPELINE_STAGES": "Opportunities may shift within the pipeline if you delete a stage or change its probability."
        },
        "PLACEHOLDER": {
          "PIPELINE_NAME": "My new pipeline"
        }
      },
      "MODALS": {
        "DELETE_TITLE": "Delete pipeline?",
        "DELETE_MESSAGE": "Deleting a pipeline with opportunities in it will cause them to no longer show on the pipeline board. Ensure that you have removed all opportunities from this pipeline before deleting it.",
        "UNSAVED_CHANGES_TITLE": "Unsaved changes",
        "UNSAVED_CHANGES_MESSAGE": "Are you sure you want to leave? You will lose any unsaved changes.",
        "UNSAVED_CHANGES_CONFIRM": "Discard changes"
      },
      "SNACKBARS": {
        "CREATE_FAILED": "Failed to create a new pipeline, please try again later.",
        "CREATE_SUCCESS": "Successfully created a new pipeline",
        "DELETE_FAILED": "Failed to delete pipeline, please try again later.",
        "DELETE_SUCCESS": "Successfully deleted pipeline",
        "SAVE_SUCCESS": "Successfully updated pipeline",
        "SAVE_FAILED": "Failed to update pipeline, please try again later.",
        "FORM_INVALID": "Failed to update pipeline, please make sure all fields are correct."
      },
      "DEFAULTS": {
        "NAME": "My new pipeline",
        "STAGE_ONE": "Demo scheduled",
        "STAGE_TWO": "Proposal requested",
        "STAGE_THREE": "Negotiation initiated",
        "STAGE_FOUR": "Contract sent",
        "CLOSED_WON": "Closed won",
        "CLOSED_LOST": "Closed lost"
      },
      "EMPTY_STATE": {
        "TITLE": "Create your first pipeline",
        "MESSAGE": "Track and manage your sales opportunities from start to close"
      }
    }
  },
  "LEADERBOARD": {
    "TITLE": "Leaderboard",
    "COLUMNS": {
      "RANK": "Rank",
      "NAME": "Name",
      "INBOUND_CALLS": "Inbound calls",
      "OUTBOUND_CALLS": "Outbound calls",
      "INBOUND_EMAILS": "Inbound emails",
      "OUTBOUND_EMAILS": "Outbound emails",
      "MEETINGS": "Meetings"
    },
    "AGGREGATIONS": {
      "TOTAL": "Total",
      "AVERAGE": "Average"
    },
    "TIME_RANGE": "Time range",
    "DATE_RANGES": {
      "THIS_MONTH": "This month",
      "LAST_MONTH": "Last month",
      "THIS_YEAR": "This year",
      "LAST_YEAR": "Last year",
      "CUSTOM": "Custom"
    },
    "CUSTOM_RANGE": {
      "START": "Start date",
      "END": "End date"
    },
    "DELETED_USER": "Deleted User"
  },
  "CUSTOM_OBJECT": {
    "ASSOCIATION_FORM": {
      "TITLE": "Custom objects",
      "PLACEHOLDER": "Associate custom object..."
    },
    "VALIDATION_ERROR": {
      "RESTRICTED_VALUE": "{{label}} value is not allowed for {{customObjectName}}",
      "EMPTY_FIELD": "{{label}} cannot be empty for {{customObjectName}}",
      "FIELD_WITHOUT_IDENTIFICATION": "{{label}} must have identification for {{customObjectName}}",
      "DUPLICATE_FIELD_ID": "Duplicate {{label}} field detected for {{customObjectName}}",
      "FIELD_DEFINITION_NOT_FOUND": "{{label}} field definition not found for {{customObjectName}}",
      "UNSUPPORTED_FIELD_TYPE": "{{label}} field type is not supported for {{customObjectName}}",
      "INVALID_VALUE_TYPE": "{{label}} has invalid value type for {{customObjectName}}",
      "TAG_EXCEEDS_LIMIT": "{{label}} tag exceeds character limit for {{customObjectName}}",
      "TAG_CANNOT_BE_EMPTY": "{{label}} tag cannot be empty for {{customObjectName}}",
      "INVALID_EMAIL": "{{label}} has invalid email format for {{customObjectName}}",
      "INVALID_CURRENCY_CODE": "{{label}} has invalid currency code for {{customObjectName}}",
      "PHONE_NATIONAL_NUMBER_EXCEEDS_LIMIT": "{{label}} phone number exceeds character limit for {{customObjectName}}",
      "PHONE_COUNTRY_CODE_EXCEEDS_LIMIT": "{{label}} country code exceeds character limit for {{customObjectName}}",
      "PHONE_EXTENSION_EXCEEDS_LIMIT": "{{label}} phone extension exceeds character limit for {{customObjectName}}",
      "STRING_EXCEEDS_LIMIT": "{{label}} exceeds character limit for {{customObjectName}}",
      "STRING_LIST_ITEM_EXCEEDS_LIMIT": "{{label}} list item exceeds character limit for {{customObjectName}}",
      "INVALID_URL": "{{label}} has invalid URL format for {{customObjectName}}",
      "GEOPOINT_LATITUDE_OUT_OF_RANGE": "{{label}} latitude must be between -90 and 90 degrees for {{customObjectName}}",
      "GEOPOINT_LONGITUDE_OUT_OF_RANGE": "{{label}} longitude must be between -180 and 180 degrees for {{customObjectName}}",
      "NOT_A_NUMBER": "{{label}} must be a number for {{customObjectName}}",
      "NOT_A_WHOLE_NUMBER": "{{label}} must be a whole number for {{customObjectName}}",
      "NOT_A_DATE": "{{label}} must be a date for {{customObjectName}}",
      "NOT_A_DATETIME": "{{label}} must be a date and time for {{customObjectName}}",
      "NOT_A_BOOLEAN": "{{label}} must be true or false for {{customObjectName}}",
      "NOT_A_CURRENCY_AMOUNT": "{{label}} must be a currency amount for {{customObjectName}}",
      "NOT_A_GEOPOINT": "{{label}} must be a latitude and longitude for {{customObjectName}}",
      "NOT_A_PHONE_NUMBER": "{{label}} must be a valid phone number for {{customObjectName}}",
      "RESTRICTED_VALUE_WITH_OPTIONS": "\"{{value}}\" is not one of the options for the {{customObjectName}} field \"{{label}}\". Change it to one of: {{acceptedValues}}"
    },
    "BULK_DELETE": {
      "TITLE": "Delete all items?",
      "CONFIRMATION_MESSAGE": "Are you sure you want to delete all {{ amount }} items?"
    },
    "STANDARD_FIELD_RULES": {
      "CUSTOM_OBJECT": {
        "CUSTOM_OBJECT_NAME_REQUIRED": "Name is required",
        "TAG_LIMIT": "This record cannot have more than 25 tags"
      }
    }
  },
  "TICKET": {
    "TITLE": "Tickets",
    "OBJECT_TYPE": "Ticket",
    "ALL_OBJECTS": "All tickets",
    "MY_OBJECTS": "My tickets",
    "ADD_OBJECT_BUTTON": "Create ticket",
    "VIEW_OBJECT": "View ticket",
    "LIST_OBJECTS_TABLE": {
      "EMPTY_TABLE": {
        "IMAGE_ALT": "Graphic showing a ticket",
        "HEADER": "No tickets yet",
        "HINT": "Tickets will appear here as they are created"
      },
      "ACTIONS": {
        "EDIT": {
          "TITLE": "View ticket"
        },
        "DELETE": {
          "ACTION": "Delete ticket",
          "TITLE": "Delete ticket?",
          "CONFIRMATION_MESSAGE": "This cannot be undone.",
          "CONFIRMATION_TEXT": "DELETE",
          "INSTRUCTIONS": "Type DELETE to confirm.",
          "CONFIRM": "Delete",
          "CANCEL": "Cancel",
          "SUCCESS": "Deleted ticket",
          "ERROR": "Error deleting ticket"
        },
        "DELETE_SELECTED": {
          "ACTION": "Delete tickets",
          "TITLE": "Delete tickets?",
          "CONFIRMATION_MESSAGE": "This cannot be undone.",
          "CONFIRMATION_TEXT": "DELETE",
          "INSTRUCTIONS": "Type DELETE to confirm.",
          "CONFIRM": "Delete",
          "CANCEL": "Cancel",
          "SUCCESS": "Deleted tickets",
          "ERROR": "Error deleting tickets"
        }
      }
    },
    "TABLE_FILTERS": {
      "HEADER": "Tickets"
    }
  },
  "OBJECT": {
    "TITLE": "{{ pluralObjectName }}",
    "TITLE_SINGLE": "{{ singularObjectName }}",
    "ADD_OBJECT_BUTTON": "Create {{ singularObjectName }}",
    "CREATE_PAGE": {
      "TITLE": "Create {{ singularObjectName }}",
      "SAVE": {
        "SUCCESS": "{{ singularObjectName }} creation was successful",
        "ERROR": "Something went wrong"
      },
      "LOAD": {
        "ERROR": "Something went wrong"
      }
    },
    "EDIT_PAGE": {
      "TITLE": "Edit {{ singularObjectName }}",
      "SAVE": {
        "SUCCESS": "{{ singularObjectName }} was updated successfully"
      }
    },
    "PROFILE_PAGE": {
      "TITLE": "{{ singularObjectName }} profile",
      "EDIT": "Edit {{ singularObjectName }}",
      "PREVIOUS_PAGE_TITLE": "{{ pluralObjectName }}",
      "ABOUT_TAB": "About",
      "ACTIVITIES_TIMELINE_TAB": "Activity",
      "ASSOCIATIONS_TAB": "Associations"
    },
    "LIST_OBJECTS_TABLE": {
      "PIPELINE": {
        "EMPTY_STATE": {
          "TITLE": "Set up your pipeline and create your first {{ singularObjectName }}",
          "MESSAGE": "Start with a default pipeline, or create a custom pipeline",
          "SETUP_PIPELINE": "Set up pipeline"
        }
      },
      "EMPTY_TABLE": {
        "IMAGE_ALT": "Graphic showing a {{singularObjectName}} to be filled in",
        "HEADER": "Create your first {{singularObjectName}}",
        "HINT": "Add a single {{singularObjectName}}"
      },
      "ACTIONS": {
        "EDIT": {
          "TITLE": "Edit {{ singularObjectName }}"
        },
        "DELETE": {
          "ACTION": "Delete {{ singularObjectName }}",
          "TITLE": "Delete {{ singularObjectName }}?",
          "CONFIRMATION_MESSAGE": "This cannot be undone.",
          "CONFIRMATION_TEXT": "DELETE",
          "INSTRUCTIONS": "Type DELETE to confirm.",
          "CONFIRM": "Delete",
          "CANCEL": "Cancel",
          "SUCCESS": "Deleted {{ singularObjectName }}",
          "ERROR": "Error deleting {{ singularObjectName }}"
        },
        "DELETE_SELECTED": {
          "ACTION": "Delete {{ pluralObjectName }}",
          "TITLE": "Delete {{ pluralObjectName }}?",
          "CONFIRMATION_MESSAGE": "This cannot be undone.",
          "CONFIRMATION_TEXT": "DELETE",
          "INSTRUCTIONS": "Type DELETE to confirm.",
          "CONFIRM": "Delete",
          "CANCEL": "Cancel",
          "SUCCESS": "Deleted {{ pluralObjectName }}",
          "ERROR": "Error deleting {{ pluralObjectName }}"
        }
      }
    },
    "TABLE_FILTERS": {
      "HEADER": "{{ pluralObjectName }}"
    },
    "RECORD_CHANGE_ACTIVITY": {
      "CREATED": "{{ singularObjectName }} created",
      "CREATED_VIA": "{{ singularObjectName }} created via",
      "DETAILS_UPDATED": "{{ singularObjectName }} details updated",
      "IMPORTANT_FIELD_UPDATED": "{{updatedField}} updated by",
      "IMPORTANT_FIELD_UPDATED_SALESPERSON": "Assigned to",
      "IMPORTANT_FIELD_UPDATED_SALESPERSON_NOT_ASSIGNED": "Unassigned",
      "IMPORTANT_FIELD_UPDATED_SALESPERSON_UNKNOWN": "deleted salesperson"
    },
    "ASSOCIATION_PANEL": {
      "TITLE": "{{ pluralObjectName }}",
      "ADD_ASSOCIATION": "Add {{ singularObjectName }}",
      "TITLE_ASSOCIATE": "Add {{ pluralObjectName }} to {{objectName}}",
      "CREATE_BUTTON": "Create and associate a new {{ singularObjectName }}",
      "CONFIRM_EXISTING_PRIMARY_MODAL": {
        "TITLE": "Are you sure you want to proceed?",
        "CONFIRMATION_MESSAGE": "The following {{ pluralObjectName }} already have primary associations and won't be created as primary:"
      },
      "EDIT_OBJECT": "Edit {{singularObjectName}}"
    },
    "SELECT_MODAL": {
      "ONE_SELECTED": "Add {{singularObjectName}}",
      "MORE_SELECTED": "Add {{totalSelected}} {{pluralObjectName}}",
      "NO_SELECTED": "Please select a {{singularObjectName}}",
      "CREATE_NEW": "Create new {{singularObjectName}}"
    }
  },
  "HISTORY_MODAL": {
    "BUTTON_LABEL": "History",
    "BUTTON_ARIA_LABEL": "Show object history",
    "TITLE": "{{objectType}} history",
    "LOADING": "Loading history...",
    "ERROR": "Unable to load history at this time.",
    "NO_HISTORY": "No history entries found for this {{objectType}}.",
    "CLOSE": "Close",
    "UNKNOWN_FIELD": "Unknown field",
    "COLUMNS": {
      "CHANGE_TYPE": "Change type",
      "DATE": "Date",
      "CHANGED_BY": "Changed by",
      "CHANGES": "Changes"
    },
    "CHANGED_BY": {
      "SYSTEM": "System"
    },
    "CHANGE_TYPES": {
      "CREATE": "Created",
      "UPDATE": "Updated",
      "UNKNOWN": "Changed"
    },
    "BOOLEAN": {
      "YES": "Yes",
      "NO": "No"
    },
    "VALUE": {
      "REMOVED": "(removed)",
      "NONE": "(no value)"
    },
    "TIMER": {
      "STATUS": {
        "INACTIVE": "Not started",
        "ACTIVE": "Running",
        "PAUSED": "Paused",
        "EXPIRED": "Expired",
        "STOPPED": "Stopped",
        "TERMINATED": "Terminated",
        "UNKNOWN": "Unknown status"
      },
      "ENDS_AT": "ends {{date}}"
    }
  },
  "RECORD_AUDIO": {
    "TITLE": "Recording meeting",
    "PAUSE": "Pause",
    "RESUME": "Resume",
    "STOP_AND_SAVE": "Stop & save",
    "CANCEL": "Cancel",
    "MIC_DENIED": "Microphone access is required to record. Please allow access in your device settings.",
    "TOO_SHORT": "Recording too short. Please record for at least 1 second."
  },
  "REVIEW_RECORDING": {
    "SPEED_LABEL": "Speed",
    "NAME_LABEL": "Name",
    "NAME_REQUIRED": "A name is required.",
    "CONTACT_LABEL": "Contact",
    "CONTACT_PLACEHOLDER": "Search by name, email or phone",
    "CONTACT_REQUIRED": "A contact must be selected.",
    "DISCARD_BUTTON": "Discard",
    "SAVE_BUTTON": "Save",
    "SAVING_BUTTON": "Saving…",
    "SAVE_ERROR": "Failed to save the recording. Please try again.",
    "SKIP_BACK_ARIA": "Skip back 5 seconds",
    "SKIP_FORWARD_ARIA": "Skip forward 5 seconds",
    "PLAY_ARIA": "Play",
    "PAUSE_ARIA": "Pause"
  }
}
